import { Engine1Proxy, ConciergeProxy, RestApiProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import ProcessManager from '../../../Common/Managers/ProcessManager'
import ContabilidadManager from '../../../Common/Managers/ContabilidadManager';
import _ from 'lodash';
import AxiosManager from '../../../Common/Managers/AxiosManager';
import GetApiUrlsHelper from '../../../Common/Helpers/GetApiUrlsHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const ABMMODELOS_ACTUALIZAR_DATOS_CONFIRMACION = "ABMMODELOS_ACTUALIZAR_DATOS_CONFIRMACION";
export const ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES = "ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES";
export const ABMMODELOS_ACTUALIZAR_RENGLONES = "ABMMODELOS_ACTUALIZAR_RENGLONES";
export const ABMMODELOS_ACTUALIZAR_CRITERIOS ="ABMMODELOS_ACTUALIZAR_CRITERIOS";
export const ABMMODELOS_ACTUALIZAR_DATOSEXCEL ='ABMMODELOS_ACTUALIZAR_DATOSEXCEL';
export const ABMMODELOS_ACTUALIZAR_OPCION_ELEGIDA = "ABMMODELOS_ACTUALIZAR_OPCION_ELEGIDA";
export const ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR = "ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR";
export const ABMMODELOS_ACTUALIZAR_VALORES_MODAL_ALTA_EDICION_RENGLON = "ABMMODELOS_ACTUALIZAR_VALORES_MODAL_ALTA_EDICION_RENGLON";
export const ABMMODELOS_ACTUALIZAR_VALORES_MODAL_COPIAR_RENGLON = "ABMMODELOS_ACTUALIZAR_VALORES_MODAL_COPIAR_RENGLON";
export const ABMMODELOS_AGREGAR_RENGLON = "ABMMODELOS_AGREGAR_RENGLON";
export const ABMMODELOS_AGREGAR_ELIMINAR_RENGLON_CONTABLE = "ABMMODELOS_AGREGAR_ELIMINAR_RENGLON_CONTABLE";
export const ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES = "ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES";
export const ABMMODELOS_ACTUALIZAR_PANTALLA_ABMMODELOS = "ABMMODELOS_ACTUALIZAR_PANTALLA_ABMMODELOS";
export const ABMMODELOS_CAMBIAR_CHECK = "ABMMODELOS_CAMBIAR_CHECK";
export const ABMMODELOS_CAMBIAR_CHECK_PANTALLA_PRINCIPAL = "ABMMODELOS_CAMBIAR_CHECK_PANTALLA_PRINCIPAL";
export const ABMMODELOS_CAMBIAR_RENGLON_BOTON_DESPLEGABLE = "ABMMODELOS_CAMBIAR_RENGLON_BOTON_DESPLEGABLE";
export const ABMMODELOS_CAMBIAR_VALOR_INPUT = "ABMMODELOS_CAMBIAR_VALOR_INPUT";
export const ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR = "ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR";
export const ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR_POR_NOMBRE = "ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR_POR_NOMBRE";
export const ABMMODELOS_CARGAR_CAMPO_IMPORTE = "ABMMODELOS_CARGAR_CAMPO_IMPORTE";
export const ABMMODELOS_CARGAR_COMBOS_CRITERIOS_CONTABLES = "ABMMODELOS_CARGAR_COMBOS_CRITERIOS_CONTABLES";
export const ABMMODELOS_CARGAR_CUENTAS_CONTABLES = "ABMMODELOS_CARGAR_CUENTAS_CONTABLES";
export const ABMMODELOS_CARGAR_PERMISOS_USUARIO = "ABMMODELOS_CARGAR_PERMISOS_USUARIO";
export const ABMMODELOS_CARGAR_SELECTORES_CRITERIOS_CONTABLES = "ABMMODELOS_CARGAR_SELECTORES_CRITERIOS_CONTABLES";
export const ABMMODELOS_FILTRAR_CUENTAS = "ABMMODELOS_FILTRAR_CUENTAS";
export const ABMMODELOS_CARGAR_CUENTAS_CONTABLES_FILTRADAS = "ABMMODELOS_CARGAR_CUENTAS_CONTABLES_FILTRADAS";
export const ABMMODELOS_FILTRAR_CUENTAS_COPIAR_RENGLON = "ABMMODELOS_FILTRAR_CUENTAS_COPIAR_RENGLON";
export const ABMMODELOS_FILTRAR_INDICADORES_INTERFAZ = "ABMMODELOS_FILTRAR_INDICADORES_INTERFAZ";
export const ABMMODELOS_FILTRAR_MODELOS = "ABMMODELOS_FILTRAR_MODELOS";
export const ABMMODELOS_FILTRAR_MODELOS_IMPORTAR = "ABMMODELOS_FILTRAR_MODELOS_IMPORTAR";
export const ABMMODELOS_GUARDAR_CANTIDADES_REEMPLAZADAS = "ABMMODELOS_GUARDAR_CANTIDADES_REEMPLAZADAS";
export const ABMMODELOS_GUARDAR_DATOS_SAGA_REEMPLAZAR_CUENTA = "ABMMODELOS_GUARDAR_DATOS_SAGA_REEMPLAZAR_CUENTA";
export const ABMMODELOS_GUARDAR_QUITAR_MODELO_SELECCIONADO = "ABMMODELOS_GUARDAR_QUITAR_MODELO_SELECCIONADO";
export const ABMMODELOS_GUARDAR_VALOR_INPUT_SELECCIONADO = "ABMMODELOS_GUARDAR_VALOR_INPUT_SELECCIONADO";
export const ABMMODELOS_IMPORTAR_MODELO = "ABMMODELOS_IMPORTAR_MODELO";
export const ABMMODELOS_INPUT_ACTIVO = "ABMMODELOS_INPUT_ACTIVO";
export const ABMMODELOS_INPUT_ACTIVO_BUSCADOR_MODELOS = "ABMMODELOS_INPUT_ACTIVO_BUSCADOR_MODELOS";
export const ABMMODELOS_MOSTRAR_RESULTADOS_INDICADOR_INTERFAZ = "ABMMODELOS_MOSTRAR_RESULTADOS_INDICADOR_INTERFAZ";
export const ABMMODELOS_MOSTRAR_FILTRAR_MODAL_REEMPLAZAR = "ABMMODELOS_MOSTRAR_FILTRAR_MODAL_REEMPLAZAR";
export const ABMMODELOS_MOSTRAR_INPUT_IMPORTAR_MODELOS = "ABMMODELOS_MOSTRAR_INPUT_IMPORTAR_MODELOS";
export const ABMMODELOS_MOSTRAR_MODAL = "ABMMODELOS_MOSTRAR_MODAL";
export const ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO = "ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO";
export const ABMMODELOS_MOSTRAR_RESULTADOS_IMPORTAR_MODELOS = "ABMMODELOS_MOSTRAR_RESULTADOS_IMPORTAR_MODELOS";
export const ABMMODELOS_MOSTRAR_SPINNER = "ABMMODELOS_MOSTRAR_SPINNER";
export const ABMMODELOS_OCULTAR_BOTON_VERMAS = "ABMMODELOS_OCULTAR_BOTON_VERMAS";
export const ABMMODELOS_REINICIAR_VALORES_MODAL = "ABMMODELOS_REINICIAR_VALORES_MODAL";
export const ABMMODELOS_RENGLON_EDICION = "ABMMODELOS_RENGLON_EDICION";
export const ABMMODELOS_SELECCIONAR_OPCION_COMBO = "ABMMODELOS_SELECCIONAR_OPCION_COMBO";
export const ABMMODELOS_SELECCIONAR_RB = "ABMMODELOS_SELECCIONAR_RB";
export const ABMMODELOS_TIPOS_MOVIMIENTO = 'ABMMODELOS_TIPOS_MOVIMIENTO';
export const ABMMODELOS_LIMPIEZA_CUENTA_SELECCIONADA = "ABMMODELOS_LIMPIEZA_CUENTA_SELECCIONADA";
export const ABMMODELOS_VALIDAR_FORMULARIO = "ABMMODELOS_VALIDAR_FORMULARIO";
export const INITIAL_STATE = "INITIAL_STATE";
export const ROUTE_TO_MODELOS_CONTABLES = "ROUTE_TO_MODELOS_CONTABLES";

//Definicion de variables globales
let _dispatch = null;
let _getState = null;
let _executionContext = null;

/*
    ABMModelos\ABMModelos.jsx
*/
export function cargarInformacionABMModelos(currentScope, modeloEdicion, executionContext) {
    LogHelper.In(cargarInformacionABMModelos.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _getState = getState;
        _executionContext = executionContext;

        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: true });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _cargarInformacionPantalla(data, modeloEdicion), null, "GETFUNCTIONS", currentScopeRequest);
    }
}


    function _cargarInformacionPantalla(data, modeloEdicion) {
        let permisos = [];

        data.CONTABILIDAD.forEach(p => { permisos[p.Codigo_Funcion] = true  });

        _dispatch({ type: ABMMODELOS_CARGAR_PERMISOS_USUARIO, permisos });

        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_BUSQUEDA', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_CUENTA_CONTABLE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        if(modeloEdicion) {
            let param = {
                'MODELO_ID': modeloEdicion
            }

            Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        } else {
            Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_SUGERENCIA_MODELO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        }

        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_DATOS_CABECERA', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_MARCA', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_SUCURSAL', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_MONEDA', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_CENTRO_COSTO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_INDICADOR_INTERFAZ', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_ATLAS_PARAMETRO_GENERAL_CONTABLE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _obtencionDatosPantallaPrincipalABMModelos(data, modeloEdicion), null, null, "CONTABILIDAD");
    }


    function _obtencionDatosPantallaPrincipalABMModelos(data, modeloEdicion) {
        let datosPantallaEdicion = {
            datosPantalla: [],
            criteriosRenglon: []
        };
        let sugerenciaModelo = undefined;
        let marcasActivasFiltradas = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_MARCA).Recordset0.Rows;
        let monedasActivasFiltradas = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_MONEDA).Recordset0.Rows;
        let centroDeCostosActivos = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CENTRO_COSTO).Recordset0.Rows;
        let sucursalesActivasFiltradas = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_SUCURSAL).Recordset0.Rows;
        let indicadoresInterfazActivosFiltrados = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_INDICADOR_INTERFAZ).Recordset0.Rows;
        let modelosActivos = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_DATOS_CABECERA).Recordset0.Rows;
        let datosMakerChecker = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_ATLAS_PARAMETRO_GENERAL_CONTABLE).Recordset0.Rows;
        let marcaEdicion = undefined;
        let monedaEdicion = undefined;
        let sucursalEdicion = undefined;
        let indicadorInterfazEdicion = undefined;
        let tipoSucursalEdicion = undefined;
        let tipoConsolidacionEdicion = undefined;
        let codigoModeloEdicion = undefined;
        let nombreModeloEdicion = undefined;
        let diasDiferimientoEdicion = undefined;
        let abreSucursal = undefined;
        let abreSocio = undefined;
        let confirmacionAutomatica = undefined;
        let requiereReverso = undefined;
        let descripcionIndicadorInterfazSeleccionado = "";


        if(modeloEdicion) {
            datosPantallaEdicion = {
                datosPantalla: JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset0.Rows,
                criteriosRenglon: JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset1.Rows
            };
        } else {
            sugerenciaModelo = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_SUGERENCIA_MODELO).Recordset0.Rows[0];
        }


        if(datosPantallaEdicion.datosPantalla.length > 0) {
            //Si la marca obtenida es igual a NULL, le asigno el valor "0" para que lo encuentre en el array de marcas activas.
            let administradoraAd17 = datosPantallaEdicion.datosPantalla[0].AdministradoraId ? datosPantallaEdicion.datosPantalla[0].AdministradoraId : 0;

            //Si la marca obtenida del modelo a editar no se encuentra en el array de marcas activas, entonces lo agrego para que figure en la pantalla de ABM de Modelos
            marcasActivasFiltradas = agregarRegistroInactivo(marcasActivasFiltradas, 
                                                             administradoraAd17, 
                                                             datosPantallaEdicion.datosPantalla[0].AdministradoraCodigo, 
                                                             datosPantallaEdicion.datosPantalla[0].AdministradoraDescripcion);

            //Me guardo la marca correspondiente al modelo a editar recibida de la obtención de datos
            marcaEdicion = datosPantallaEdicion.datosPantalla[0]?.AdministradoraCodigo;



            //Si la moneda obtenida del modelo a editar no se encuentra en el array de monedas activas, entonces lo agrego para que figure en la pantalla de ABM de Modelos
            monedasActivasFiltradas = agregarRegistroInactivo(monedasActivasFiltradas, 
                                                              datosPantallaEdicion.datosPantalla[0].ModeloMonedaId, 
                                                              datosPantallaEdicion.datosPantalla[0].ModeloMonedaCodigo, 
                                                              datosPantallaEdicion.datosPantalla[0].ModeloMonedaDescripcion);


            //Me guardo la moneda correspondiente al modelo a editar recibida de la obtención de datos
            monedaEdicion = datosPantallaEdicion.datosPantalla[0].ModeloMonedaCodigo;



            //Si la sucursal obtenida del modelo a editar no se encuentra en el array de sucursales activas, entonces lo agrego para que figure en la pantalla de ABM de Modelos. Valido no recibir NULL como Sucursal (NULL == "Todas")
            if(datosPantallaEdicion.datosPantalla[0].SucursalId) {
                sucursalesActivasFiltradas = agregarRegistroInactivo(sucursalesActivasFiltradas, 
                                                                    datosPantallaEdicion.datosPantalla[0].SucursalId, 
                                                                    datosPantallaEdicion.datosPantalla[0].SucursalCodigo, 
                                                                    datosPantallaEdicion.datosPantalla[0].SucursalDescripcion);
            }


            //Me guardo la sucursal correspondiente al modelo a editar recibida de la obtención de datos
            sucursalEdicion = datosPantallaEdicion.datosPantalla[0].SucursalId;



            //No preciso aplicar la lógica de contemplar registros inactivos ya que son RB "quemados"
            //Me guardo el Tipo de sucursal correspondiente al modelo a editar recibida de la obtención de datos
            tipoSucursalEdicion = datosPantallaEdicion.datosPantalla[0].TipoSucursal;



            //No preciso aplicar la lógica de contemplar registros inactivos ya que son RB "quemados"
            //Me guardo el Tipo de sucursal correspondiente al modelo a editar recibida de la obtención de datos
            tipoConsolidacionEdicion = datosPantallaEdicion.datosPantalla[0].TipoConsolidacion;



            //Si el indicador de interfaz obtenido del modelo a editar no se encuentra en el array de indicadores de interfaz activos, entonces lo agrego para que figure en la pantalla de ABM de Modelos.
            indicadoresInterfazActivosFiltrados = agregarRegistroInactivo(indicadoresInterfazActivosFiltrados, 
                                                                          datosPantallaEdicion.datosPantalla[0].IndicadorInterfazId, 
                                                                          datosPantallaEdicion.datosPantalla[0].IndicInterfazCodigo, 
                                                                          datosPantallaEdicion.datosPantalla[0].IndicInterfazDescripcion);


            //Me guardo el indicador de interfaz correspondiente al modelo a editar recibida de la obtención de datos
            indicadorInterfazEdicion = datosPantallaEdicion.datosPantalla[0].IndicadorInterfazId;


            abreSucursal = datosPantallaEdicion.datosPantalla[0].AbreSucursal;
            abreSocio = datosPantallaEdicion.datosPantalla[0].AbreSocio;
            confirmacionAutomatica = datosPantallaEdicion.datosPantalla[0].ConfirmacionAutomatica;
            requiereReverso = datosPantallaEdicion.datosPantalla[0].RequiereReverso;


            codigoModeloEdicion = datosPantallaEdicion.datosPantalla[0].ModeloContableCabeceraId;
            nombreModeloEdicion = datosPantallaEdicion.datosPantalla[0].DescripcionModelo;
            diasDiferimientoEdicion = datosPantallaEdicion.datosPantalla[0].DiasDiferimiento;
            
            descripcionIndicadorInterfazSeleccionado = indicadoresInterfazActivosFiltrados.filter(ind => {return ind.Id == indicadorInterfazEdicion});
            descripcionIndicadorInterfazSeleccionado = descripcionIndicadorInterfazSeleccionado[0].Codigo + " - " + descripcionIndicadorInterfazSeleccionado[0].Descripcion;
        }

        let datosRenglonesExcel = datosPantallaEdicion.datosPantalla.length > 0 ? armarDatosExportacionExcel(datosPantallaEdicion.datosPantalla, datosPantallaEdicion.criteriosRenglon) : [];

        let datosPantalla = {
            modelosContables: JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_BUSQUEDA).Recordset0.Rows,
            modelosActivos: modelosActivos,
            cuentasContables: JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CUENTA_CONTABLE).Recordset0.Rows,
            modeloEdicion: modeloEdicion,
            datosPantallaEdicion,
            sugerenciaModelo: sugerenciaModelo?.CodigoModelo,
            marcasActivas: marcasActivasFiltradas,
            sucursalesActivas: sucursalesActivasFiltradas,
            monedasActivas: monedasActivasFiltradas,
            centroDeCostosActivos: centroDeCostosActivos,
            indicadoresInterfazActivos: indicadoresInterfazActivosFiltrados,
            marcaEdicion,
            monedaEdicion,
            sucursalEdicion,
            tipoSucursalEdicion,
            indicadorInterfazEdicion,
            tipoConsolidacionEdicion,
            codigoModeloEdicion,
            nombreModeloEdicion,
            diasDiferimientoEdicion,
            datosRenglonesExcel,
            descripcionIndicadorInterfazSeleccionado,
            abreSucursal,
            abreSocio,
            confirmacionAutomatica,
            requiereReverso
        }

        _dispatch({ type: ABMMODELOS_CARGAR_CUENTAS_CONTABLES, datosPantalla, datosMakerChecker});

        //Valido los renglones que no fueron eliminados desde la grilla
        let renglonesIguales = _validarRenglonesIguales(datosPantallaEdicion.datosPantalla.filter(renglon => {return !renglon.DeleteInstance}));

        if(renglonesIguales.existenRenglonesIguales) {
            _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: "Existen renglones con las mismas características: N° " + renglonesIguales.renglon1 + " y N° " + renglonesIguales.renglon2 + "."});
        } else {
            _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: ""});
        }

        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
    }

/* 
    ABMModelos\ABMModelosActions.js
*/

        export function actualizarConfirmacionModelo() {
            return (dispatch, _getState) => {
                _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: true });
                let idModelo = _getState().abmModelos.modeloEdicion;
                let usuario = _executionContext.login;
                let param = {
                    'ID_MODELO': idModelo,
                    'USUARIO': usuario
                }
                Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_SET_USUARIO_FECHA_CONFIRMACION', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
                Engine1Proxy.Execute((data) => _respuestaActualizacionConfirmacionModelo(data), null, null, "CONTABILIDAD");
            }
        }
        function _respuestaActualizacionConfirmacionModelo(data) {
    
                let idModelo = _getState().abmModelos.modeloEdicion;
                let param = {
                    'MODELO_ID': idModelo
                }
                Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
                Engine1Proxy.Execute((data) => _refrescarPantallaABMModelos(data), null, null, "CONTABILIDAD");
            }
        
        function _refrescarPantallaABMModelos(data) {
            let datosPantalla = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset0.Rows;
            _dispatch({type: ABMMODELOS_ACTUALIZAR_PANTALLA_ABMMODELOS,datosPantalla});
            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
        }
/* 
    ABMModelos\ABMModelos.jsx
*/
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
         sessionStorage.setItem('PantallaCambios', false);

        _dispatch({ type: INITIAL_STATE });
    };
}


/* 
    ABMModelos\SeccionRenglonesModelo\SeccionRenglonesModelo.jsx
    ABMModelos\Modales\ModalCopiarRenglonContable\ModalCopiarRenglonContable.jsx
    ABMModelos\SeccionRenglonesModelo\RegistroRenglonModelo.jsx
    ABMModelos\Modales\ModalAltaEdicionRenglonontable\ModalAltaEdicionRenglonontable.jsx
*/
export function mostrarOcultarModalABMModelos(nombreModal, mostrarModal) {
    LogHelper.In(mostrarOcultarModalABMModelos.name, nombreModal, mostrarModal);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal, mostrarModal });

        if(!mostrarModal) {
            _dispatch({ type: ABMMODELOS_REINICIAR_VALORES_MODAL, nombreModal });
        }
    };
}


/* 
    Common\BuscadorCuentasContables.jsx
*/
export function buscarCuentasContables(seccionInput, nombreInput, valorInput) {
    LogHelper.In(buscarCuentasContables.name, seccionInput, nombreInput, valorInput);

    return (dispatch, getState) => {
        let cuentasContables = getState().abmModelos.cuentasContables;
        let cuentasSeleccionadas = getState().abmModelos.inputsABMModelos[seccionInput].cuentasSeleccionadas;
        let radiosModal = getState().abmModelos.radioButtonsABMModelos.modalAltaEdicionRenglonContable;

        let cuentasContablesFiltradosBuscador = obtenerOpcionesCuentasFiltradas(cuentasContables, cuentasSeleccionadas, nombreInput, valorInput);

        if(seccionInput == "modalAltaEdicionRenglonContable"){
            let monedasActivas = _getState().abmModelos.monedasActivas;
            let monedaIdSeleccionada = monedasActivas.filter(mon => mon.Codigo == (radiosModal.rbMonedaSalida == "P" ? "PESO" : "DOLAR"))[0].Id;

            if(radiosModal.rbTipoOperacion != 0) {
                cuentasContables = cuentasContables.filter((cuenta) => cuenta.TipoOperacion == radiosModal.rbTipoOperacion || cuenta.TipoOperacion == 0)
            }
            cuentasContables = cuentasContables.filter((cuenta) => cuenta.MonedaId == monedaIdSeleccionada || cuenta.MonedaId == 0 )

        
            cuentasContablesFiltradosBuscador = obtenerOpcionesCuentasFiltradas(cuentasContables, cuentasSeleccionadas, nombreInput, valorInput);
        }
        if(seccionInput == "modalCopiarRenglonContable") {
            let cuentaCopiada = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.renglon));
            let cuentaCopiadaTipoOperacion = JSON.parse(JSON.stringify(getState().abmModelos.radioButtonsABMModelos.modalCopiarRenglonContable.rbTipoOperacion));

            //Elimino la cuenta original del renglón copiado para que no se visualice en el dropdown de cuentas filtradas.
            cuentaCopiadaTipoOperacion == "D" ?
                cuentasContablesFiltradosBuscador = cuentasContablesFiltradosBuscador.filter((cuenta) => cuenta.TipoOperacion == 1 || cuenta.TipoOperacion == 0)
            :   cuentasContablesFiltradosBuscador = cuentasContablesFiltradosBuscador.filter((cuenta) => cuenta.TipoOperacion == 2 || cuenta.TipoOperacion == 0)

            if (cuentaCopiada.ModeloMonedaId != 0) {
                cuentasContablesFiltradosBuscador = cuentasContablesFiltradosBuscador.filter((cuenta) => cuenta.MonedaId == cuentaCopiada.ModeloMonedaId || cuenta.MonedaId == 0);
            }

            _dispatch({ type: ABMMODELOS_FILTRAR_CUENTAS_COPIAR_RENGLON, cuentasContablesFiltradosBuscador, seccionInput, nombreInput, valorInput });
        } else {
            _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre: "modalReemplazarCuentasContables", valor: "" });
            _dispatch({ type: ABMMODELOS_FILTRAR_CUENTAS, cuentasContablesFiltradosBuscador, seccionInput, nombreInput, valorInput });
        }
    }
}


/* 
    ABMModelos\Modales\ModalReemplazarCuentasContables\ModalReemplazarCuentasContables.jsx
*/
export function cambiarEstadoCheckABMModelos(nombreModal, nombreCheck, valor) {
    LogHelper.In(cambiarEstadoCheckABMModelos.name, nombreModal, nombreCheck, valor);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_CHECK, nombreModal, nombreCheck, valor });
    }
}


/* 
    Common\BuscadorCuentasContables.jsx
    Common\CuentasContablesRegistrosBuscador.jsx
*/
export function cambiarInputActivo(seccionInput, nombreInput) {
    LogHelper.In(cambiarInputActivo.name, seccionInput, nombreInput);

    return (dispatch, getState) => {
        let cuentasContables = getState().abmModelos.cuentasContables;
        let cuentasSeleccionadas = getState().abmModelos.inputsABMModelos[seccionInput].cuentasSeleccionadas;
        let valorInput = getState().abmModelos.inputsABMModelos[seccionInput][nombreInput];

        let cuentasContablesFiltradosBuscador = obtenerOpcionesCuentasFiltradas(cuentasContables, cuentasSeleccionadas, nombreInput, valorInput);

        _dispatch({ type: ABMMODELOS_INPUT_ACTIVO, seccionInput, nombreInput, cuentasContablesFiltradosBuscador });
    }
}


/* 
    Common\CuentasContablesRegistrosBuscador.jsx
*/
export function guardarValorInput(seccionInput, nombreInput, valorInput, descripcionInput) {
    LogHelper.In(guardarValorInput.name, seccionInput, nombreInput, valorInput, descripcionInput);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre: "modalReemplazarCuentasContables", valor: "" });
        _dispatch({ type: ABMMODELOS_GUARDAR_VALOR_INPUT_SELECCIONADO, seccionInput, nombreInput, valorInput, descripcionInput });
    }
}


/* 
    ABMModelos\Modales\ModalReemplazarCuentasContables\ReemplazarCuentasContables.jsx
*/
export function buscarModelosModalReemplazarCuentasContables(valorInput) {
    LogHelper.In(buscarModelosModalReemplazarCuentasContables.name, valorInput);
    let modelosFiltradosBuscador = [];

    return (dispatch, getState) => {
        let modelos = getState().abmModelos.modelosContablesActivos;
        let modelosSeleccionados = getState().abmModelos.inputsABMModelos.modalReemplazarCuentasContables.modelosSeleccionados;
        let modeloEdicion = getState().abmModelos.modeloEdicion;

        modelosFiltradosBuscador = busquedaModelosContables(modelos, modelosSeleccionados, valorInput, modeloEdicion)

        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre: "modalReemplazarCuentasContables", valor: "" });
        _dispatch({ type: ABMMODELOS_FILTRAR_MODELOS, modelosFiltradosBuscador, valorInput });
    }
}

 
/* 
    ABMModelos\Modales\ModalReemplazarCuentasContables\ModelosContablesRegistrosBuscador.jsx
    ABMModelos\Modales\ModalReemplazarCuentasContables\ReemplazarCuentasContables.jsx
*/
export function cambiarInputBuscadorModelosActivo(nombreInput) {
    LogHelper.In(cambiarInputBuscadorModelosActivo.name, nombreInput);
    let modelosFiltradosBuscador = [];

    return (dispatch, getState) => {
        let modelos = getState().abmModelos.modelosContablesActivos;
        let modelosSeleccionados = getState().abmModelos.inputsABMModelos.modalReemplazarCuentasContables.modelosSeleccionados;
        let inputBuscador = getState().abmModelos.inputsABMModelos.modalReemplazarCuentasContables.inputModelos;
        let modeloEdicion = getState().abmModelos.modeloEdicion;

        modelosFiltradosBuscador = busquedaModelosContables(modelos, modelosSeleccionados, inputBuscador, modeloEdicion)

        _dispatch({ type: ABMMODELOS_INPUT_ACTIVO_BUSCADOR_MODELOS, nombreInput, modelosFiltradosBuscador });
    }
}


/* 
    ABMModelos\Modales\ModalReemplazarCuentasContables\ModelosContablesRegistrosBuscador.jsx
    ABMModelos\Modales\ModalReemplazarCuentasContables\ModelosSeleccionados.jsx
    ABMModelos\Modales\ModalReemplazarCuentasContables\ReemplazarCuentasContables.jsx
*/
export function guardarQuitarModeloSeleccionado(seccionInput, modelo, adicionarModelo) {
    LogHelper.In(guardarQuitarModeloSeleccionado.name, seccionInput, modelo, adicionarModelo);

    return (dispatch, getState) => {
        let modelos = getState().abmModelos.modelosContablesActivos;

        let modeloSeleccionado = modelo == "Todos" ? modelo : modelos.filter(m => {return m.Codigo == modelo})[0];

        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre: "modalReemplazarCuentasContables", valor: "" });
        _dispatch({ type: ABMMODELOS_GUARDAR_QUITAR_MODELO_SELECCIONADO, seccionInput, modeloSeleccionado, adicionarModelo });
    }
}


/* 
    ABMModelos\Modales\ModalReemplazarCuentasContables\ModelosSeleccionados.jsx
*/
export function ocultarBotonVerMas() {
    LogHelper.In(ocultarBotonVerMas.name);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_OCULTAR_BOTON_VERMAS });
    }
}


/*
    ABMModelos\Cabecera.jsx
*/
export function validarGuardarModelo() {
    LogHelper.In(validarGuardarModelo.name);

    return (dispatch, getState) => {
        let erroresValidacion = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));
        let modelos = JSON.parse(JSON.stringify(getState().abmModelos.modelosContables));
        let marcas = JSON.parse(JSON.stringify(getState().abmModelos.marcasActivas));
        let monedas = JSON.parse(JSON.stringify(getState().abmModelos.monedasActivas));
        let modeloEdicion = getState().abmModelos.modeloEdicion;
        let datosPantalla = getState().abmModelos.datosPantalla;
        let renglones = JSON.parse(JSON.stringify(getState().abmModelos.datosRenglones));
        let criterios = JSON.parse(JSON.stringify(getState().abmModelos.criteriosRenglon));
        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos));
        let checks = JSON.parse(JSON.stringify(getState().abmModelos.checksABMModelos));
        let radioButtons = JSON.parse(JSON.stringify(getState().abmModelos.radioButtonsABMModelos));
        let combos = JSON.parse(JSON.stringify(getState().abmModelos.combosABMModelos));

        if(modeloEdicion) {
            modelos = modelos.filter(modelo => modelo.Codigo != modeloEdicion);
        }

        let renglonesSinEliminar = renglones.filter(renglon => !renglon.DeleteInstance);
        let resultadoValidacion = _validarFormularioModelo(erroresValidacion, inputs, modelos, renglonesSinEliminar);

        _dispatch({ type: ABMMODELOS_VALIDAR_FORMULARIO, erroresValidacion: resultadoValidacion.erroresValidacion });

        //Le doy formato a los datos finales de modelo, renglones y criterios para impactar en la BD a través de una Rule
        if(!resultadoValidacion.hayError) {
            //Me guardo la fecha de baja recibida por SP (en el caso de ser una Edición) o la fecha actual del día (en caso de ser un Alta)
            let arrayFechaBaja = datosPantalla && datosPantalla.length > 0 && datosPantalla[0].FechaBaja ? new Date(datosPantalla[0].FechaBaja).toLocaleDateString("en-GB").split("/") : new Date().toLocaleDateString("en-GB").split("/");
            let fechaBaja = arrayFechaBaja && arrayFechaBaja[1] + "-" + arrayFechaBaja[0] + "-" + arrayFechaBaja[2];

            let objetoCabecera = {
                AbreSocio: checks.checkAperturaPorSocio ? 1 : 0,
                AbreSucursal: checks.checkAperturaPorSucursal ? 1 : 0,
                AdministradoraId: marcas.filter(marca => {return marca.Codigo == radioButtons.rbMarca})[0].Id,
                ConfirmacionAutomatica: checks.checkConfirmacionAutomatica ? 1 : 0,
                Descripcion: inputs.inputNombreModelo.trim(),
                DiasDiferimiento: parseInt(inputs.inputDiasDiferimiento),
                EsEdicion: Boolean(modeloEdicion),
                FechaBaja: checks.checkModeloHabilitado ? null : fechaBaja,
                Id: inputs.inputCodigoModelo,
                IndicadorInterfazId: inputs.indicadorInterfazSeleccionado,
                ModeloContableCabeceraTmpId: modeloEdicion ? null : 1,
                ModeloMonedaId: monedas.filter(moneda => {return moneda.Codigo == radioButtons.rbMoneda})[0].Id,
                TipoConsolidacion: radioButtons.rbTipoConsolidacion,
                TipoSucursal: radioButtons.rbTipoSucursal,
                RequiereReverso: checks.checkRequiereReverso ? 1 : 0,
                SucursalId: combos.comboSucursal == 0 ? null : combos.comboSucursal,
                UsuarioAlta: modeloEdicion ? null : _executionContext.login,
                Login: _executionContext.login,
                Terminal: _executionContext.terminalId
            }

            let arrayRenglones = renglones.map(renglon => {
                return {
                    CampoImporteId: renglon.CampoImporteId,
                    CentroCostoId: renglon.CentroCostoId,
                    CuentaContableId: renglon.CuentaContableId,
                    DeleteInstance: Boolean(renglon.DeleteInstance),
                    Descripcion: renglon.DescripcionRenglon,
                    Id: renglon.ModeloContableDetalleId,
                    ModeloCabeceraId: inputs.inputCodigoModelo,
                    ModeloContableCabeceraTmpId: modeloEdicion ? null : 1,
                    ModeloDetalleTmpId: renglon.ModeloContableDetalleId ? null : renglon.referenciaRenglonCriterio,
                    ModeloMonedaSalidaId: renglon.ModeloMonedaSalidaId,
                    NroRenglon: renglon.NroRenglon,
                    SignoCampo: renglon.SignoCampo,
                    TipoApertura: renglon.TipoApertura,
                    TipoRenglon: renglon.TipoRenglon,
                    TipoReferencia: renglon.TipoReferencia,
                    TipoOperacion: renglon.TipoOperacion,
                    TipoMovimientoId: renglon.TipoMovimientoId,
                    ValorReferencia: renglon.ValorReferencia
                }
            });

            let arrayCriterios = criterios.map(criterio => {
                return {
                    Id: criterio.Id || '',
                    CampoCriterioId: criterio.CampoCriterioId || '',
                    DeleteInstance: Boolean(criterio.DeleteInstance),
                    ModeloDetalleId: criterio.ModeloDetalleId || '',
                    ModeloDetalleTmpId: criterio.ModeloDetalleId ? '' : criterio.referenciaRenglonCriterio,
                    ValorCriterio:  criterio.ValorCriterio == "Todos" || !criterio.ValorCriterio ? '' : criterio.ValorCriterio
                }
            });

            let xmlCriterios = "";

            xmlCriterios += arrayCriterios.map(criterio => {
                return `<Criterio Id='${criterio.Id}' CampoCriterioId='${criterio.CampoCriterioId}' DeleteInstance='${criterio.DeleteInstance}' ModeloDetalleId='${criterio.ModeloDetalleId}' ModeloDetalleTmpId='${criterio.ModeloDetalleTmpId}' ValorCriterio='${criterio.ValorCriterio}' />`
            }).join('');

            let parametrosModelos = {
                MODELO_CABECERA_CONTAINER: objetoCabecera,
                MODELO_DETALLE_CONTAINER: arrayRenglones,
                MODELO_DETALLE_CRITERIO_CONTAINER: xmlCriterios
            };

            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: true });

            Engine1Proxy.AddRuleRequests(parametrosModelos, 'ABMMODELOSCONTABLES', 'Tarjetas', 'CONTABILIDAD');
            Engine1Proxy.Execute((data) => _callbackABMModelos(data), null, null, "CONTABILIDAD");
        }
    }
}

    function _callbackABMModelos(result) {
        LogHelper.In(_callbackABMModelos.name, result);

        let resultado = JSON.parse(result.ABMMODELOSCONTABLES);
        let modeloEdicion = _getState().abmModelos.modeloEdicion;

        if(!resultado.EsError) {
            if(modeloEdicion) {
                let param = {
                    'MODELO_ID': modeloEdicion
                }

                Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
                Engine1Proxy.Execute((data) => _callbackActualizarPantallaPrincipal(data, resultado.Mensaje), null, null, "CONTABILIDAD");
            } else {
                _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
                _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: resultado.Mensaje, redireccionarPantallaPrincipal: true });
            }
        } else {
            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
            _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Hubo un error durante la transacción, no fue posible concretar el guardado del modelo. Comuníquese con soporte para más información. [Mensaje: " + resultado.Mensaje + "]", redireccionarPantallaPrincipal: false });
        }
    }

    function _callbackActualizarPantallaPrincipal(data, mensajeResultado) {
        let dataConfirmacion = JSON.parse(JSON.stringify(_getState().abmModelos.datosPantalla));
        let renglones = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset0.Rows;
        let criterios = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset1.Rows;

        dataConfirmacion[0].UsuarioConfirmacion = renglones[0].UsuarioConfirmacion;
        dataConfirmacion[0].FechaConfirmacion = renglones[0].FechaConfirmacion;

        _dispatch({ type: ABMMODELOS_ACTUALIZAR_DATOS_CONFIRMACION, dataConfirmacion });
        _dispatch({ type: ABMMODELOS_ACTUALIZAR_RENGLONES, renglones });
        _dispatch({ type: ABMMODELOS_ACTUALIZAR_CRITERIOS, criterios });
        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
        _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: mensajeResultado, redireccionarPantallaPrincipal: false });
        sessionStorage.setItem('PantallaCambios', false);
    }


    function _validarFormularioModelo(erroresValidacion, inputs, modelos, renglones) {
        let resultadoValidacion = {
            hayError: false,
            erroresValidacion
        }

        erroresValidacion.inputCodigoModelo = "";
        erroresValidacion.inputNombreModelo = "";
        erroresValidacion.inputIndicadorInterfaz = "";
        erroresValidacion.inputDiasDiferimiento = "";
        erroresValidacion.seccionRenglones = "";


        //Validacion de input de Código de Modelo
        if(!inputs.inputCodigoModelo) {
            erroresValidacion.inputCodigoModelo = "Se debe ingresar un valor para el código del modelo";

            resultadoValidacion = {
                hayError: true,
                erroresValidacion
            }
        }

        if(!erroresValidacion.inputCodigoModelo) {
            let existeCodigo = modelos.filter(modelo => modelo.Codigo == inputs.inputCodigoModelo).length > 0;

            if(existeCodigo) {
                erroresValidacion.inputCodigoModelo = "El código ingresado ya existe, ingrese un valor diferente";

                resultadoValidacion = {
                    hayError: true,
                    erroresValidacion
                }
            }
        }


        //Validacion de input de Nombre de Modelo
        if(!inputs.inputNombreModelo.trim()) {
            erroresValidacion.inputNombreModelo = "Se debe ingresar un valor para el nombre del modelo";

            resultadoValidacion = {
                hayError: true,
                erroresValidacion
            }
        }


        //Validacion de input de Nombre de Modelo
        if(!inputs.inputDiasDiferimiento) {
            erroresValidacion.inputDiasDiferimiento = "Se debe ingresar un valor para días de diferimiento";

            resultadoValidacion = {
                hayError: true,
                erroresValidacion
            }
        }


        //Validacion de input de Indicador de interfaz
        if(!inputs.indicadorInterfazSeleccionado) {
            erroresValidacion.inputIndicadorInterfaz = "Se debe ingresar un valor para el indicador de interfaz";

            resultadoValidacion = {
                hayError: true,
                erroresValidacion
            }
        }


        //Validacion de existencia de un renglón contable al DEBE y otro al HABER bajo la misma moneda de salida
        let errorValidacionRenglones = false;
        let renglonesHaber = renglones.filter(renglon => renglon.TipoOperacion == 1);
        let renglonesDebe = renglones.filter(renglon => renglon.TipoOperacion == 2);
        let monedasSalida = [...new Set(renglonesHaber.map(renglon => renglon.MonedaSalidaCodigo))];

        if(renglonesHaber.length == 0 || renglonesDebe.length == 0) {
            errorValidacionRenglones = true;
        } else {
            //Filtrar en un array por moneda de salida (agrupar monedas del haber y monedas del debe y deben existir por lo menos un registro en ambos tipo de operacion)
            monedasSalida.forEach(moneda => {
                let cantidadMonedaSalidaHaber = renglonesHaber.filter(renglon => renglon.MonedaSalidaCodigo == moneda).length;
                let cantidadMonedaSalidaDebe = renglonesDebe.filter(renglon => renglon.MonedaSalidaCodigo == moneda).length;

                if(cantidadMonedaSalidaHaber == 0 || cantidadMonedaSalidaDebe == 0) {
                    errorValidacionRenglones = true;
                }
            });
        }

        if(errorValidacionRenglones) {
            erroresValidacion.seccionRenglones = "Debe existir por lo menos un renglón al DEBE y al HABER asociado a la misma moneda de salida";

            resultadoValidacion = {
                hayError: true,
                erroresValidacion
            }
        }

        //Limpio los mensajes de error de validación en el caso de que no haya habido ninguna validación con error
        if(!resultadoValidacion.hayError) {
            erroresValidacion.inputCodigoModelo = "";
            erroresValidacion.inputNombreModelo = "";
            erroresValidacion.inputIndicadorInterfaz = "";
            erroresValidacion.inputDiasDiferimiento = "";
            erroresValidacion.seccionRenglones = "";

            resultadoValidacion = {
                hayError: false,
                erroresValidacion
            }

        }

        return resultadoValidacion;
    }


    function _validarRenglonesIguales(renglones) {
        let renglonesIguales = {
            existenRenglonesIguales: false,
            renglon1: null,
            renglon2: null
        }

        renglones.map(renglon => {
            let renglonA = {
                modeloCabeceraId: renglon.ModeloContableCabeceraId,
                tipoRenglon: renglon.TipoRenglon,
                tipoApertura: renglon.TipoApertura,
                tipoReferencia: renglon.TipoReferencia,
                valorReferencia: renglon.ValorReferencia,
                modeloMonedaSalidaId: renglon.ModeloMonedaSalidaId,
                tipoOperacion: renglon.TipoOperacion,
                cuentaContableId: renglon.CuentaContableId,
                centroCostoId: renglon.CentroCostoId,
                tipoMovimientoId: renglon.TipoMovimientoId,
                campoImporteId: renglon.CampoImporteId,
                signoCampo: renglon.SignoCampo
            }

            let arrayRenglonesComparacion = renglones.filter(ren => ren.NroRenglon > renglon.NroRenglon);
            
            arrayRenglonesComparacion.map(renglonComparacion => {
                let renglonB = {
                    modeloCabeceraId: renglonComparacion.ModeloContableCabeceraId,
                    tipoRenglon: renglonComparacion.TipoRenglon,
                    tipoApertura: renglonComparacion.TipoApertura,
                    tipoReferencia: renglonComparacion.TipoReferencia,
                    valorReferencia: renglonComparacion.ValorReferencia,
                    modeloMonedaSalidaId: renglonComparacion.ModeloMonedaSalidaId,
                    tipoOperacion: renglonComparacion.TipoOperacion,
                    cuentaContableId: renglonComparacion.CuentaContableId,
                    centroCostoId: renglonComparacion.CentroCostoId,
                    tipoMovimientoId: renglonComparacion.TipoMovimientoId,
                    campoImporteId: renglonComparacion.CampoImporteId,
                    signoCampo: renglonComparacion.SignoCampo
                }

                if(_.isEqual(renglonA, renglonB)) {
                    renglonesIguales = {
                        existenRenglonesIguales: true,
                        renglon1: renglon.NroRenglon,
                        renglon2: renglonComparacion.NroRenglon
                    }
                }
            });
        })

        return renglonesIguales;
    }


/*
    ABMModelos\Cabecera.jsx
*/
export function routeToModelosContables(id, dispatch) {
    LogHelper.In(routeToModelosContables.name, id, dispatch);

    return (dispatch) => {
        _routing(id, ROUTE_TO_MODELOS_CONTABLES, dispatch);
    }
}

    function _routing(id, option, dispatch) {
        LogHelper.In(_routing.name, id, option, dispatch);

        if (id) {
            id = JSON.stringify(id);
        }

        const redirectLocation = ProcessManager.GetNextStep("ModelosContables", option, id);

        _dispatch({ type: ROUTE_TO_MODELOS_CONTABLES, data: redirectLocation })
    }


/*
    ABMModelos\SeccionDatosGenerales\SeccionDatosGenerales.jsx
*/
export function cambiarCheckABMModelos(nombreCheck, valor) {
    LogHelper.In(cambiarCheckABMModelos.name, nombreCheck, valor);

    return (dispatch) => {
        sessionStorage.setItem('PantallaCambios', true);

        _dispatch({ type: ABMMODELOS_CAMBIAR_CHECK_PANTALLA_PRINCIPAL, nombreCheck, valor});
    }
}
/*
    ABMModelos\Modales\ModalCopiarRenglonContable.jsx
*/

export function seleccionarRbDefaultSocios() {
    LogHelper.In(seleccionarRbDefaultSocios.name);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB: "modalAltaEdicionRenglonContable", nombreRB: "rbTipoApertura", valorRB: 2 });
    }
}

/*
    ABMModelos\SeccionDatosGenerales\SeccionDatosGenerales.jsx
    ABMModelos\Modales\ModalCopiarRenglonContable\ModalCopiarRenglonContable.jsx
*/
export function seleccionarRadioButtonABMModelos(seccionRB, nombreRB, valorRB) {
    LogHelper.In(seleccionarRadioButtonABMModelos.name, seccionRB, nombreRB, valorRB);
    let cuentaSeleccionada = JSON.parse(JSON.stringify(_getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.cuentasSeleccionadas.inputCuentaContable));
    let cuentaSeleccionadaAlta = JSON.parse(JSON.stringify(_getState().abmModelos.inputsABMModelos.modalAltaEdicionRenglonContable.cuentasSeleccionadas.inputCuentaContable));
    let radiosSeleccionados = JSON.parse(JSON.stringify(_getState().abmModelos.radioButtonsABMModelos.modalAltaEdicionRenglonContable))

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB, valorRB });
        if (seccionRB === undefined){
            sessionStorage.setItem('PantallaCambios', true);
        }
        let cuentasFiltradas = _getState().abmModelos.cuentasContables;//Vienen del modelo - las uso como base pero las que termino mostrando son las filtradas del modal
        let renglonOriginal = _getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.renglon;
        if (seccionRB == "modalCopiarRenglonContable" && nombreRB == "rbTipoOperacion") {

            if (cuentaSeleccionada != "") {

                let borrarCuentaSeleccionada = true;
                let datoCuentaSeleccionada = cuentasFiltradas.filter((cuenta) => cuenta.Codigo == cuentaSeleccionada)[0]
                borrarCuentaSeleccionada = valorRB == "D" ?
                    datoCuentaSeleccionada.TipoOperacion != 1 && datoCuentaSeleccionada.TipoOperacion != 0
                    :
                    datoCuentaSeleccionada.TipoOperacion != 2 && datoCuentaSeleccionada.TipoOperacion != 0;

                _dispatch({ type: ABMMODELOS_LIMPIEZA_CUENTA_SELECCIONADA, borrarCuentaSeleccionada, seccionInput: "modalCopiarRenglonContable", nombreInput: "inputCuentaContable", valorInput: "" });
            } else {

                valorRB == "D"
                    ? cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.TipoOperacion == 1 || cuenta.TipoOperacion == 0)
                    : cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.TipoOperacion == 2 || cuenta.TipoOperacion == 0)

                if (renglonOriginal.ModeloMonedaId != 0) {
                    cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.MonedaId == renglonOriginal.ModeloMonedaId || cuenta.MonedaId == 0);
                }
                //Le agregamos la seccion
                _dispatch({ type: ABMMODELOS_CARGAR_CUENTAS_CONTABLES_FILTRADAS, cuentasFiltradas, seccionRB });

            }
        }
        
        let checkAperturaPorSocio = JSON.parse(JSON.stringify(_getState().abmModelos.checksABMModelos.checkAperturaPorSocio));
        let rbABModelo = JSON.parse(JSON.stringify(_getState().abmModelos.radioButtonsABMModelos.modalAltaEdicionRenglonContable));

        if (seccionRB == "modalAltaEdicionRenglonContable") {
            if (nombreRB == "rbTipoRenglon" && valorRB != 1) {
                _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB: "rbTipoApertura", valorRB: checkAperturaPorSocio ? 2 : 1});

                _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB: "rbReferenciaRenglon", valorRB: 0 });
                _dispatch({ type: ABMMODELOS_SELECCIONAR_OPCION_COMBO,  nombreCombo: "comboTipoMovimientoSeleccionado", valorCombo: null });
                _dispatch({ type: ABMMODELOS_SELECCIONAR_OPCION_COMBO,  nombreCombo: "comboCampoImporteSeleccionado", valorCombo: null });
                _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB: "rbSignoImporte", valorRB: null })
            }
            if (nombreRB == "rbTipoRenglon" && valorRB != 3 && rbABModelo.rbTipoOperacion == 0 ) {
                _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB: "rbTipoOperacion", valorRB: 1 });
            }
            if (nombreRB == "rbTipoRenglon" && valorRB == 3) {
                _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB: "rbTipoOperacion", valorRB: 0 });
            }
            if (nombreRB == "rbTipoApertura" && valorRB == 1 && rbABModelo.rbReferenciaRenglon == 1){
                _dispatch ({type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB: "rbReferenciaRenglon", valorRB: 0})
            }
            if (nombreRB == "rbReferenciaRenglon" && valorRB != 3 ){
                _dispatch ({type: ABMMODELOS_CAMBIAR_VALOR_INPUT, seccionInput: "modalAltaEdicionRenglonContable", nombreInput: "inputReferenciaRenglon", valorInput: ""})
            }         
        }
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB, nombreRB, valorRB });

        if (seccionRB == "modalAltaEdicionRenglonContable" && nombreRB == "rbTipoOperacion" || nombreRB == "rbMonedaSalida" || nombreRB == "rbTipoRenglon") {
            radiosSeleccionados = JSON.parse(JSON.stringify(_getState().abmModelos.radioButtonsABMModelos.modalAltaEdicionRenglonContable))
            let monedasActivas = _getState().abmModelos.monedasActivas;
            let monedaIdSeleccionada = monedasActivas.filter(mon => mon.Codigo == ((radiosSeleccionados.rbMonedaSalida.toString() == "P" || radiosSeleccionados.rbMonedaSalida.toString() == "1" ) ? "PESO" : "DOLAR"))[0].Id;

            
            if (cuentaSeleccionadaAlta != "") {
                let datoCuentaSeleccionada = cuentasFiltradas.filter(cuenta => cuenta.Codigo == cuentaSeleccionadaAlta)[0];

                let borrarCuentaSeleccionada = (datoCuentaSeleccionada.TipoOperacion != radiosSeleccionados.rbTipoOperacion && datoCuentaSeleccionada.TipoOperacion != 0)
                                        || (datoCuentaSeleccionada.MonedaId != monedaIdSeleccionada && datoCuentaSeleccionada.MonedaId != 0)

                _dispatch({ type: ABMMODELOS_LIMPIEZA_CUENTA_SELECCIONADA, borrarCuentaSeleccionada, seccionInput: seccionRB, nombreInput: "inputCuentaContable", valorInput: "" });
            }

            if(radiosSeleccionados.rbTipoOperacion != 0) {
                cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.TipoOperacion == radiosSeleccionados.rbTipoOperacion || cuenta.TipoOperacion == 0 )
            }
            cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.MonedaId == monedaIdSeleccionada || cuenta.MonedaId == 0 )

            _dispatch({ type: ABMMODELOS_CARGAR_CUENTAS_CONTABLES_FILTRADAS, cuentasFiltradas , seccionRB});    
        }
    };
}

function cargarValoresAltaEdicionRenglonContable(renglon) {
    LogHelper.In(cargarValoresAltaEdicionRenglonContable.name);


        let cuentasFiltradas = JSON.parse(JSON.stringify(_getState().abmModelos.cuentasContables));
        let descripcionCuenta = renglon.CuentaContableCodigo + " - " + renglon.CuentaContableDescripcion;
        
        _dispatch({ type: ABMMODELOS_GUARDAR_VALOR_INPUT_SELECCIONADO,seccionInput: "modalAltaEdicionRenglonContable", nombreInput: "inputCuentaContable", valorInput: renglon.CuentaContableCodigo, descripcionInput: descripcionCuenta});
   
        if (renglon.TipoOperacion != 0) {
            cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.TipoOperacion == 1 || cuenta.TipoOperacion == 0)
            cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.TipoOperacion == 2 || cuenta.TipoOperacion == 0)
        }

        if (renglon.ModeloMonedaId != 0) {
            cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.MonedaId == renglon.ModeloMonedaId || cuenta.MonedaId == 0);
        }

        _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALORES_MODAL_ALTA_EDICION_RENGLON, cuentasFiltradas, renglon});
}



/*
    ABMModelos\SeccionDatosGenerales\SeccionDatosGenerales.jsx
*/
export function cambiarOpcionCombo(nombreCombo, valorCombo) {
    LogHelper.In(cambiarOpcionCombo.name, nombreCombo, valorCombo);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre: nombreCombo, valor: false });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_OPCION_COMBO, nombreCombo, valorCombo });
        if (nombreCombo == "comboSucursal") {
            sessionStorage.setItem('PantallaCambios', true);
        }
        if (nombreCombo == "comboTipoMovimientoSeleccionado") {
            cargarInformacionComboImporte(valorCombo);
            cargarInformacionCriteriosContables(valorCombo);

            let errores = JSON.parse(JSON.stringify(_getState().abmModelos.errorValidacion));
            errores.modalAltaEdicionRenglonContable.combosCriteriosContables= "";
            _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores})

            let combos = JSON.parse(JSON.stringify(_getState().abmModelos.combosABMModelos));
            combos.modalAltaEdicionRenglonContable.contenedorCombosCriteriosContables.forEach(
                element =>  delete combos[element.nombreCombo]
            )
            //Se reutiliza el dispatch para reiniciar los valores de los combos seleccionados
            _dispatch({ type: ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES, combos})
            
        }
    };
}

export function cambiarOpcionComboCriterios(nombreCombo, valorCombo) {
    LogHelper.In(cambiarOpcionComboCriterios.name, nombreCombo, valorCombo);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre: nombreCombo, valor: false });
        
        let combos = JSON.parse(JSON.stringify(_getState().abmModelos.combosABMModelos));
        
        combos.modalAltaEdicionRenglonContable.contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreCombo})[0].valoresCriterios.map(e => e.estaSeleccionado = false)

        if(valorCombo != 0){
            combos.modalAltaEdicionRenglonContable.contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreCombo})[0].valoresCriterios.filter(f => {return f.Id == valorCombo})[0].estaSeleccionado = true;
            combos.modalAltaEdicionRenglonContable.contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreCombo})[0].valorSeleccionado = valorCombo;
        }
        
        _dispatch({ type: ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES, combos})
    };
}


/*
    ABMModelos\SeccionDatosGenerales\SeccionDatosGenerales.jsx
*/
export function cambiarValorInput(seccionInput, nombreInput, valorInput) {
    LogHelper.In(cambiarValorInput.name, nombreInput, valorInput);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_INPUT, seccionInput, nombreInput, valorInput });
        if (seccionInput === undefined) {
            sessionStorage.setItem('PantallaCambios', true)
        }
    } 
}


/*
    ABMModelos\SeccionRenglonesModelo\RegistroRenglonModelo.jsx
*/
export function mostrarOcultarDatosAdicionalesRenglon(idRenglon, valorDesplegable) {
    LogHelper.In(mostrarOcultarDatosAdicionalesRenglon.name, idRenglon, valorDesplegable);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_RENGLON_BOTON_DESPLEGABLE, idRenglon, valorDesplegable });
    };
}


/*
    ABMModelos\SeccionRenglonesModelo\RegistroRenglonModelo.jsx
    ABMModelos\Modales\ModalConfirmarEliminacionRenglon\ModalConfirmarEliminacionRenglon.jsx
*/
export function agregarEliminarRenglonContable(nroRenglon, seAgrega, mostrarConfirmacion) {
    LogHelper.In(agregarEliminarRenglonContable.name, nroRenglon, seAgrega, mostrarConfirmacion);

    return (dispatch, getState) => {
        if(mostrarConfirmacion) {
            _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal: "modalConfirmarBorrarRenglon", mostrarModal: true, nroRenglon, seAgrega });
        } else {
            let datosRenglones = JSON.parse(JSON.stringify(getState().abmModelos.datosRenglones));
            let datosCriterios = JSON.parse(JSON.stringify(getState().abmModelos.criteriosRenglon));
            let arrayRenglonesArreglados = [];
            let arrayCriteriosArreglados = [];

            if(seAgrega) {
                arrayRenglonesArreglados = datosRenglones;

                _dispatch({ type: ABMMODELOS_AGREGAR_ELIMINAR_RENGLON_CONTABLE, datosRenglones: arrayRenglonesArreglados, datosCriterios });
            } else {
                let esRenglonNuevo = datosRenglones.filter(renglon => renglon.NroRenglon == nroRenglon)[0].referenciaRenglonCriterio;

                //Elimino los criterios asociados al renglón eliminado
                if(esRenglonNuevo >= 0) {
                    arrayCriteriosArreglados = datosCriterios.filter(criterio => {return criterio.referenciaRenglonCriterio != esRenglonNuevo});

                    //Elimino el número de renglón seleccionado y ordeno el array nuevamente por número de renglón
                    arrayRenglonesArreglados = datosRenglones.filter(renglon => {return renglon.NroRenglon != nroRenglon}).sort((a,b) => a.NroRenglon - b.NroRenglon);
                } else {
                    //Actualizo los criterios ya existentes y les agrego un campo "DeleteInstance" para que en el guardado se den de baja
                    datosCriterios.map(criterio => {
                        if(criterio.ModeloDetalleId == datosRenglones.filter(renglon => renglon.NroRenglon == nroRenglon)[0].ModeloContableDetalleId){
                            return criterio["DeleteInstance"] = true
                        } else {
                            return criterio
                        }
                    });

                    arrayCriteriosArreglados = datosCriterios;

                    //Actualizo los renglones ya existentes y les agrego un campo "DeleteInstance" para que en el guardado se den de baja
                    datosRenglones.map(renglon => {
                        if(renglon.NroRenglon == nroRenglon){
                            return renglon["DeleteInstance"] = true
                        } else {
                            return renglon
                        }
                    }).sort((a,b) => a.NroRenglon - b.NroRenglon);

                    arrayRenglonesArreglados = datosRenglones;
                }

                //Re-Ordeno el array dejando los renglones sin eliminar al principio y los que se borran al final, luego ordeno de menor a mayor los renglones contemplando el re-ordenamiento inicial para poder re-asignar los renglones correctamente
                arrayRenglonesArreglados = arrayRenglonesArreglados.sort((a,b) => {return a.DeleteInstance ? 1 : -1});
                arrayRenglonesArreglados = arrayRenglonesArreglados.sort((a,b) => {return a.DeleteInstance ? 1 : (a.NroRenglon > b.NroRenglon ? 1 : -1)}).map((renglon,index) => {renglon.NroRenglon = index + 1; return renglon});

                _dispatch({ type: ABMMODELOS_AGREGAR_ELIMINAR_RENGLON_CONTABLE, datosRenglones: arrayRenglonesArreglados, datosCriterios: arrayCriteriosArreglados });
            }

            //Valido los renglones que no fueron eliminados desde la grilla
            let renglonesIguales = _validarRenglonesIguales(arrayRenglonesArreglados.filter(renglon => {return !renglon.DeleteInstance}));

            if(renglonesIguales.existenRenglonesIguales) {
                _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: "Existen renglones con las mismas características: N° " + renglonesIguales.renglon1 + " y N° " + renglonesIguales.renglon2 + "."});
            } else {
                _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: ""});
            }

            _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal: "modalConfirmarBorrarRenglon", mostrarModal: false });
            sessionStorage.setItem('PantallaCambios', true);
        }
    };
}


/*
    ABMModelos\ImportarModelosContables.jsx
*/
export function mostrarOcultarImportarModelos(valor) {
    LogHelper.In(mostrarOcultarImportarModelos.name, valor);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_MOSTRAR_INPUT_IMPORTAR_MODELOS, valor });
    };
}


/*
    ABMModelos\ImportarModelosContables.jsx
*/
export function mostrarOcultarResultadosImportarModelos(valor) {
    LogHelper.In(mostrarOcultarResultadosImportarModelos.name, valor);

    return (dispatch, getState) => {
        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos));

        inputs.mostrarResultadosImportarModelo = valor;

        _dispatch({ type: ABMMODELOS_MOSTRAR_RESULTADOS_IMPORTAR_MODELOS, inputs });
    };
}


/*
    ABMModelos\ImportarModelosContables.jsx
    ABMModelos\ImportarModelosBuscador.jsx
*/
export function buscarModelosImportar(valorInput, descripcionModelo, esModeloSeleccionado, codigoSeleccionado) {
    LogHelper.In(buscarModelosImportar.name, valorInput);
    let modelosFiltradosBuscador = [];

    return (dispatch, getState) => {
        let modelos = getState().abmModelos.modelosContablesActivos;
        let modelosSeleccionados = [];
        let modeloEdicion = getState().abmModelos.modeloEdicion;
        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos));

        modelosFiltradosBuscador = busquedaModelosContables(modelos, modelosSeleccionados, valorInput, modeloEdicion)

        if(esModeloSeleccionado) {
            inputs.descripcionModeloSeleccionadoImportar = descripcionModelo;
            inputs.modeloSeleccionadoImportar = codigoSeleccionado;
        } else {
            inputs.descripcionModeloSeleccionadoImportar = "";
            inputs.modeloSeleccionadoImportar = null;
        }
        
        inputs.inputImportarModelo = valorInput;
        inputs.modelosFiltradosImportarModelo = modelosFiltradosBuscador;

        _dispatch({ type: ABMMODELOS_FILTRAR_MODELOS_IMPORTAR, inputs });
    }
}


/*
    ABMModelos\ImportarModelosContables.jsx
    ABMModelos\ImportarModelosBuscador.jsx
*/
export function importarModelo(codigoModelo) {
    LogHelper.In(importarModelo.name, codigoModelo);

    return (dispatch, getState) => {
        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos));
        let checks = JSON.parse(JSON.stringify(getState().abmModelos.checksABMModelos));
        let radioButtons = JSON.parse(JSON.stringify(getState().abmModelos.radioButtonsABMModelos));
        let combos = JSON.parse(JSON.stringify(getState().abmModelos.combosABMModelos));
        let indicadoresInterfazActivos = JSON.parse(JSON.stringify(getState().abmModelos.indicadoresInterfazActivos));

        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: true });

        let param = {
            'MODELO_ID': codigoModelo
        }
    
        Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.Execute((data) => _recargarPantallaABMModelos(data, inputs, checks, radioButtons, combos, indicadoresInterfazActivos), null, null, "CONTABILIDAD");
    };
}


    function _recargarPantallaABMModelos(data, inputs, checks, radioButtons, combos, indicadoresInterfazActivos) {
        let datosImportados = {
            datosPantalla: JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset0.Rows,
            criteriosRenglon: JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset1.Rows
        };

        let indicadoresInterfazActivosFiltrados = agregarRegistroInactivo(indicadoresInterfazActivos, 
                                                                          datosImportados.datosPantalla[0].IndicadorInterfazId, 
                                                                          datosImportados.datosPantalla[0].IndicInterfazCodigo, 
                                                                          datosImportados.datosPantalla[0].IndicInterfazDescripcion);

        //Aplico los datos obtenidos a cada uno de los inputs del formulario
        inputs.inputNombreModelo     = datosImportados.datosPantalla[0].DescripcionModelo ? datosImportados.datosPantalla[0].DescripcionModelo : "";
        inputs.inputDiasDiferimiento = datosImportados.datosPantalla[0].DiasDiferimiento ? datosImportados.datosPantalla[0].DiasDiferimiento : "";
        inputs.inputIndicadorInterfaz = datosImportados.datosPantalla[0].IndicadorInterfazId ? datosImportados.datosPantalla[0].IndicadorInterfazId : "";
        inputs.indicadorInterfazSeleccionado = datosImportados.datosPantalla[0].IndicadorInterfazId ? datosImportados.datosPantalla[0].IndicadorInterfazId : null;
        inputs.descripcionIndicadorInterfazSeleccionado = datosImportados.datosPantalla[0].IndicadorInterfazId ? datosImportados.datosPantalla[0].IndicInterfazCodigo + " - " + datosImportados.datosPantalla[0].IndicInterfazDescripcion : "";
        inputs.indicadorInterfazFiltrados = indicadoresInterfazActivosFiltrados;

        checks.checkModeloHabilitado = Boolean(!datosImportados?.datosPantalla[0]?.FechaBaja);

        radioButtons.rbMarca             = datosImportados.datosPantalla[0]?.AdministradoraCodigo ? datosImportados.datosPantalla[0]?.AdministradoraCodigo : "VISA";
        radioButtons.rbMoneda            = datosImportados.datosPantalla[0].ModeloMonedaCodigo ? datosImportados.datosPantalla[0].ModeloMonedaCodigo : "PESO";
        radioButtons.rbTipoSucursal      = datosImportados.datosPantalla[0].TipoSucursal ? datosImportados.datosPantalla[0].TipoSucursal : 1;
        radioButtons.rbTipoConsolidacion = datosImportados.datosPantalla[0].TipoConsolidacion ? datosImportados.datosPantalla[0].TipoConsolidacion : 1;

        combos.comboSucursal          = datosImportados.datosPantalla[0].SucursalId ? datosImportados.datosPantalla[0].SucursalId : 0;

        let datosRenglonesExcel = datosImportados.datosPantalla.length > 0 ? armarDatosExportacionExcel(datosImportados.datosPantalla, datosImportados.criteriosRenglon) : [];


        //AD17-1982 - Se nullean los valores de ModeloCabeceraId (Id asociado al modelo del cual se importó) y ModeloDetalleId (Id asociado al renglón del cual se importó) ya que los datos importados se corresponden con información nueva
        datosImportados.datosPantalla = datosImportados.datosPantalla.map(renglon => {return {...renglon, ModeloContableCabeceraId: null, referenciaRenglonCriterio: renglon.ModeloContableDetalleId, ModeloContableDetalleId: null}});
        datosImportados.criteriosRenglon = datosImportados.criteriosRenglon.map(criterio => {return {...criterio, Id: null, referenciaRenglonCriterio: criterio.ModeloDetalleId, ModeloDetalleId: null}});

        _dispatch({ type: ABMMODELOS_IMPORTAR_MODELO, datosImportados, inputs, checks, radioButtons, combos, datosRenglonesExcel });
        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
        sessionStorage.setItem('PantallaCambios', true);
    }


/* 
    ABMModelos\SeccionDatosGenerales\IndicadorInterfazBuscador.jsx
    ABMModelos\SeccionDatosGenerales\IndicadoresInterfaz.jsx
*/
export function buscarIndicadoresInterfaz(valorInput, descripcionIndicadorInterfaz, esIndicadorSeleccionado, idSeleccionado) {
    LogHelper.In(buscarModelosImportar.name, valorInput);
    let indicadoresInterfazFiltradosBuscador = [];

    return (dispatch, getState) => {
        let indicadoresInterfaz = getState().abmModelos.indicadoresInterfazActivos;
        let indicadorInterfazEdicion = getState().abmModelos.indicadorInterfazEdicion;
        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos));
        let errorValidacion = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));

        indicadoresInterfazFiltradosBuscador = busquedaIndicadoresInterfaz(indicadoresInterfaz, valorInput, indicadorInterfazEdicion)

        if(esIndicadorSeleccionado) {
            inputs.descripcionIndicadorInterfazSeleccionado = descripcionIndicadorInterfaz;
            inputs.indicadorInterfazSeleccionado = idSeleccionado;
            inputs.mostrarResultadosIndicadorInterfaz = false;
            errorValidacion.inputIndicadorInterfaz = false;
        } else {
            inputs.descripcionIndicadorInterfazSeleccionado = "";
            inputs.indicadorInterfazSeleccionado = null;
        }
        
        inputs.inputIndicadorInterfaz = valorInput;
        inputs.indicadorInterfazFiltrados = indicadoresInterfazFiltradosBuscador;

        _dispatch({ type: ABMMODELOS_FILTRAR_INDICADORES_INTERFAZ, inputs, errorValidacion });
        sessionStorage.setItem('PantallaCambios', true);
    }
}


/*
    ABMModelos\SeccionDatosGenerales\IndicadorInterfazBuscador.jsx
*/
export function mostrarOcultarResultadosIndicadorInterfaz(valor) {
    LogHelper.In(mostrarOcultarResultadosIndicadorInterfaz.name, valor);

    return (dispatch, getState) => {
        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos));

        inputs.mostrarResultadosIndicadorInterfaz = valor;

        _dispatch({ type: ABMMODELOS_MOSTRAR_RESULTADOS_INDICADOR_INTERFAZ, inputs });
    };
}


/*
    ABMModelos\Modales\ModalReemplazarCuentasContables\ModalReemplazarCuentasContables.jsx
*/
export function cambiarCuentasContables(codigoCuentaContableReemplazada, codigoCuentaContableNueva) {
    LogHelper.In(cambiarCuentasContables.name, codigoCuentaContableReemplazada, codigoCuentaContableNueva);

    return (dispatch, getState) => {
        let modeloEdicion = getState().abmModelos.modeloEdicion;
        let cuentasContables = JSON.parse(JSON.stringify(getState().abmModelos.cuentasContables));
        let modelosContables = JSON.parse(JSON.stringify(getState().abmModelos.modelosContablesActivos));
        let checkReemplazarMasModelos = JSON.parse(JSON.stringify(getState().abmModelos.checksABMModelos.modalReemplazarCuentasContables.checkReemplazarEnOtrosModelos));
        let modelosSeleccionados = getState().abmModelos.inputsABMModelos.modalReemplazarCuentasContables.modelosSeleccionados;
        
        let codigosModelos = "";

        let idCuentaContableReemplazada = cuentasContables.filter(cuenta => cuenta.Codigo == codigoCuentaContableReemplazada)[0]?.Id;
        let idCuentaContableNueva = cuentasContables.filter(cuenta => cuenta.Codigo == codigoCuentaContableNueva)[0]?.Id;
        //Determino si el modelo a editar está inactivo o no, para enviarlo en la obtención de datos y pueda ser contemplado. Si es un alta de modelo no aplica
        let esModeloEdicionInactivo = modeloEdicion && modelosContables.filter(modelo => modelo.Codigo == modeloEdicion).length == 0;

        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModales", valor: true });

        //Si se marcó el check para reemplazar las cuentas contables y además se seleccionaron modelos, se guarda en un string los ids de modelos seleccionados, separados por "-". Si no se marcó el check o no hay modelos seleccionados entonces se utiliza el Id del modelo que se está editando.
        if(checkReemplazarMasModelos && modelosSeleccionados.length > 0) {
            codigosModelos = modelosSeleccionados[0].Codigo == "Todos" ? modelosSeleccionados[0].Codigo : modelosSeleccionados.map(modelo => modelo.Codigo).toString().replaceAll(",","-");

            if(modeloEdicion && codigosModelos != "Todos") {
                codigosModelos += "-" + modeloEdicion.toString();
            }
        } else {
            codigosModelos = modeloEdicion.toString();
        }

        let param = {
            "IDS_MODELOS": codigosModelos,
            "ID_CUENTA_CONTABLE_REEMPLAZADA": idCuentaContableReemplazada,
            "ID_CUENTA_CONTABLE_NUEVA": idCuentaContableNueva,
            "MODELO_EDICION_INACTIVO": modeloEdicion && esModeloEdicionInactivo ? modeloEdicion.toString() : null
        }

        Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_RENGLONES_MODELOS_REEMPLAZAR', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.Execute((data) => _callbackReemplazarCuentasContables(data), null, null, "CONTABILIDAD");
    };
}

    function _callbackReemplazarCuentasContables(data) {
        let renglonesContables = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_RENGLONES_MODELOS_REEMPLAZAR).Recordset0.Rows;

        //Me guardo únicamente el Id, para poder diferenciar registros, y el CuentaContableId, que es el único valor que verdaderamente debería modificarse en la Saga.
        renglonesContables = renglonesContables.length > 0 && renglonesContables.map(renglon => {return {"Id": renglon.Id, "CuentaContableId": renglon.CuentaContableId}})

        let cantidadModelosRenglones = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_RENGLONES_MODELOS_REEMPLAZAR).Recordset1.Rows[0];

        if(cantidadModelosRenglones.CantidadRenglones == 0) {
            _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre: "modalReemplazarCuentasContables", valor: "La cuenta a reemplazar seleccionada no se ha encontrado asociada a ninguno de los modelos seleccionados." })
            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModales", valor: false });
        } else {
            _dispatch({ type: ABMMODELOS_GUARDAR_CANTIDADES_REEMPLAZADAS, cantidadRenglones: cantidadModelosRenglones.CantidadRenglones.toString(), cantidadModelos: cantidadModelosRenglones.CantidadModelos.toString() })

            ContabilidadManager.EjecutarSagasContabilidad(renglonesContables, SagasHelper.GetSagasId, _callbackCambiarCuentasContables, "SAGA_REEMPLAZAR_CUENTA_CONTABLE");
        }
    }

        function _callbackCambiarCuentasContables(result, disconectCallback) {
            LogHelper.In(_callbackCambiarCuentasContables.name, result, disconectCallback);

            let modeloEdicion = _getState().abmModelos.modeloEdicion;
            let huboError = result.Estado != 2;

            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModales", valor: false });
            _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal: "modalReemplazarCuentasContables", mostrarModal: false });
            _dispatch({ type: ABMMODELOS_REINICIAR_VALORES_MODAL, nombreModal: "modalReemplazarCuentasContables" });
            _dispatch({ type: ABMMODELOS_GUARDAR_DATOS_SAGA_REEMPLAZAR_CUENTA, huboError, sagaId: result.SagaId });

            if(!huboError && modeloEdicion) {
                let param = {
                    'MODELO_ID': modeloEdicion
                }

                _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: true });

                Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
                Engine1Proxy.Execute((data) => _callbackActualizarRenglonesContables(data), null, null, "CONTABILIDAD");
            } else {
                _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal: "modalResultadoReemplazarCuentasContables", mostrarModal: true });
            }

            disconectCallback();
        }

            function _callbackActualizarRenglonesContables(data) {
                let renglones = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset0.Rows;

                _dispatch({ type: ABMMODELOS_ACTUALIZAR_RENGLONES, renglones });
                _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
                _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal: "modalResultadoReemplazarCuentasContables", mostrarModal: true });
            }


/*
    ABMModelos\SeccionRenglonesModelo\RegistroRenglonModelo.jsx
*/
export function cargarValoresModalCopiarRenglonContable(renglon, criterios, mostrarSignoAmbos) {
    LogHelper.In(cargarValoresModalCopiarRenglonContable.name);

    return (dispatch, getState) => {
        let cuentasFiltradas = JSON.parse(JSON.stringify(getState().abmModelos.cuentasContables));
        let descripcionCuenta = renglon.CuentaContableCodigo + " - " + renglon.CuentaContableDescripcion;
        
        _dispatch({ type: ABMMODELOS_GUARDAR_VALOR_INPUT_SELECCIONADO,seccionInput: "modalCopiarRenglonContable", nombreInput: "inputCuentaContable", valorInput: renglon.CuentaContableCodigo, descripcionInput: descripcionCuenta});
   
        if (renglon.TipoOperacion != 0) {
            cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.TipoOperacion == 1 || cuenta.TipoOperacion == 0)
            cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.TipoOperacion == 2 || cuenta.TipoOperacion == 0)
        }

        if (renglon.ModeloMonedaId != 0) {
            cuentasFiltradas = cuentasFiltradas.filter((cuenta) => cuenta.MonedaId == renglon.ModeloMonedaId || cuenta.MonedaId == 0);
        }

        _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALORES_MODAL_COPIAR_RENGLON, cuentasFiltradas, renglon, criterios, mostrarSignoAmbos });
    }
}


/*
    ABMModelos\Modales\ModalCopiarRenglonContable\ModalCopiarRenglonContable.jsx    
*/
export function validarGuardarCopiaRenglon() {
    LogHelper.In(validarGuardarCopiaRenglon.name);

    return (dispatch, getState) => {
        let radioButtons = JSON.parse(JSON.stringify(getState().abmModelos.radioButtonsABMModelos.modalCopiarRenglonContable));
        let inputUltimoRenglon = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.inputNumeroRenglon));
        let cuentaSeleccionada = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.cuentasSeleccionadas.inputCuentaContable));

        if(cuentaSeleccionada == "") {
            let errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));

            errores.modalCopiarRenglonContable.inputCuentaContable = "Debe seleccionar una cuenta contable.";
            _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores});
        } 
        if(radioButtons.rbUbicacionRenglon == 2 && inputUltimoRenglon == "") {
            let errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));
            errores.modalCopiarRenglonContable.inputNumeroRenglon = "Debe ingresar un valor para el número de renglón";

            _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores});
        }   
        if (cuentaSeleccionada != "" && (radioButtons.rbUbicacionRenglon == 0 || radioButtons.rbUbicacionRenglon == 1 || (radioButtons.rbUbicacionRenglon == 2 && inputUltimoRenglon != ""))) 
        {
      
       
            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModales", valor: true });

            let cuentasContables = JSON.parse(JSON.stringify(getState().abmModelos.cuentasContables));
            let renglones = JSON.parse(JSON.stringify(getState().abmModelos.datosRenglones));
            let criterios = JSON.parse(JSON.stringify(getState().abmModelos.criteriosRenglon));
            let renglonCopiado = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.renglon));
            let criteriosCopiados = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.criterios));
            let cuentaSeleccionada = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.cuentasSeleccionadas.inputCuentaContable));
            let ultimoRenglon = parseInt(JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalCopiarRenglonContable.ultimoNumeroRenglon)));
            let renglonesArray = [];
            let referenciaRenglonCopia = JSON.parse(JSON.stringify(getState().abmModelos.referenciaRenglonCopia));

            let valorSigno = radioButtons.rbSignoImporte == "A" ? null : radioButtons.rbSignoImporte == "P" ? "+" : "-";
            let valorTipoOperacion = radioButtons.rbTipoOperacion == "D" ? 1 : 2;

            if(cuentaSeleccionada) {
                renglonCopiado.CuentaContableCodigo = cuentaSeleccionada;
                renglonCopiado.CuentaContableDescripcion = cuentasContables.filter(cuenta => cuenta.Codigo == cuentaSeleccionada)[0]?.Descripcion;
                renglonCopiado.CuentaContableId = cuentasContables.filter(cuenta => cuenta.Codigo == cuentaSeleccionada)[0]?.Id;
            }

            //Nulleo el "ModeloContableDetalleId" ya que es un renglón nuevo el cual aún no ha sido impactado en base, con lo cual no tiene un Id asociado.
            //Se realiza esto para no generar inconsistencias ni malas relaciones entre registros.
            renglonCopiado.ModeloContableDetalleId = null;
            renglonCopiado.SignoCampo = valorSigno;
            renglonCopiado.TipoOperacion = valorTipoOperacion;
            //Agrego campo "referenciaRenglonCriterio" para poder relacionar renglones copiados con los criterios correspondientes
            //Solo los renglones copiados contarán con esta propiedad
            renglonCopiado.referenciaRenglonCriterio = referenciaRenglonCopia;

            //Como último renglón del modelo
            if(radioButtons.rbUbicacionRenglon == 1) {
                renglonCopiado.NroRenglon = ultimoRenglon + 1;
                renglones = [...renglones, renglonCopiado];
            } else {
                                                                                  //Debajo del renglón seleccionado : //En la posición N:
                renglonCopiado.NroRenglon = radioButtons.rbUbicacionRenglon == 0 ? renglonCopiado.NroRenglon + 1 : parseInt(inputUltimoRenglon);
                renglonesArray = renglones.map(renglon => { if(renglon.NroRenglon >= renglonCopiado.NroRenglon) {
                                                                return {...renglon, NroRenglon: renglon.NroRenglon + 1}
                                                            } else {
                                                                return {...renglon}
                                                            }
                                                          });

                renglones = [...renglonesArray, renglonCopiado].sort((a,b) => a.NroRenglon - b.NroRenglon);
            }

            if(criteriosCopiados.length > 0) {

                criteriosCopiados = criteriosCopiados.map(crit => {return {...crit, Id: null, ModeloDetalleId: null, NroRenglon: renglonCopiado.NroRenglon, referenciaRenglonCriterio: referenciaRenglonCopia}});

                criterios = [...criterios, ...criteriosCopiados];
            }

            //Aumento en 1 el valor de referencia de copias de renglones "referenciaRenglonCopia"
            referenciaRenglonCopia += 1;

            _dispatch({ type: ABMMODELOS_AGREGAR_RENGLON, renglones, criterios, referenciaRenglonCopia });

            //Valido los renglones que no fueron eliminados desde la grilla
            let renglonesIguales = _validarRenglonesIguales(renglones.filter(renglon => {return !renglon.DeleteInstance}));

            if(renglonesIguales.existenRenglonesIguales) {
                _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: "Existen renglones con las mismas características: N° " + renglonesIguales.renglon1 + " y N° " + renglonesIguales.renglon2 + "."});
            } else {
                _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: ""});
            }

            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModales", valor: false });
            _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal: "modalCopiarRenglonContable", mostrarModal: false });
            _dispatch({ type: ABMMODELOS_REINICIAR_VALORES_MODAL, nombreModal: "modalCopiarRenglonContable" });
            sessionStorage.setItem('PantallaCambios', true);
        }
    }
}


/*
    ABMModelos\Modales\ModalCopiarRenglonContable\ModalCopiarRenglonContable.jsx
*/
export function limpiarMensajeError(nombre) {
    LogHelper.In(cambiarValorInput.name, nombre);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR, nombre, valor: ""});
    };
}

/*
    ABMModelos\Modales\ModalCopiarRenglonContable\ModalConfirmarAbandonoABMModelos.jsx
*/

/*
    ABMModelos\Modales\ModalAltaEdicionRenglonContable\ModalAltaEdicionRenglonContable.jsx
*/
export function limpiarMensajeErrorPorNombre(seccion, nombre) {
    LogHelper.In(cambiarValorInput.name, nombre);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR_POR_NOMBRE, seccion, nombre});
    };
}


//CREAR ACTION actualizarOpcionElegida que reciba como parámetro la opción clickeada ("C" o "G")
// Actualizar variable opcionElegida
 export function actualizarOpcionElegida(opcion) {
    LogHelper.In(actualizarOpcionElegida.name, opcion);

    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_ACTUALIZAR_OPCION_ELEGIDA, opcionElegida: opcion});
    };
}

export function cargarInformacionTipoMovimientos(rbMarca){

    return (dispatch) => {
    let administradoraId = rbMarca.toLowerCase() == 'visa' ? 1 : rbMarca.toLowerCase() == 'cabal' ? 2 : 3;
    administradoraId = rbMarca.toLowerCase() == 'ad17' ? null : administradoraId;
    let param = {
        'ADMINISTRADORA_ID': administradoraId
    }
    Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_TIPO_MOVIMIENTO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.Execute((data) => _callbackActualizarTiposMovimiento(data), null, null, "CONTABILIDAD");
};
}
function _callbackActualizarTiposMovimiento(data) {
    let tiposMovimiento = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_TIPO_MOVIMIENTO).Recordset0.Rows;

    _dispatch({ type: ABMMODELOS_TIPOS_MOVIMIENTO, tiposMovimiento });

    let combos = JSON.parse(JSON.stringify(_getState().abmModelos.combosABMModelos));

    if(!combos.modalAltaEdicionRenglonContable.comboTipoMovimientoSeleccionado){
        combos.modalAltaEdicionRenglonContable.comboTipoMovimientoSeleccionado = tiposMovimiento[0].Id;
        _dispatch({ type: ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES, combos });

        cargarInformacionComboImporte(tiposMovimiento[0].Id)
        cargarInformacionCriteriosContables(tiposMovimiento[0].Id)
    } else{
        cargarInformacionComboImporte(combos.modalAltaEdicionRenglonContable.comboTipoMovimientoSeleccionado)
        cargarInformacionCriteriosContables(combos.modalAltaEdicionRenglonContable.comboTipoMovimientoSeleccionado)
    }
  
}

function cargarInformacionComboImporte(tipoMovimiento){

    let rbMarca = _getState().abmModelos.radioButtonsABMModelos.rbMarca;
    let administradoraId = rbMarca.toLowerCase() == 'visa' ? 1 : rbMarca.toLowerCase() == 'cabal' ? 2 : 3;
    
    let param = {
        'TIPO_MOVIMIENTO_ID' : tipoMovimiento,
        'ADMINISTRADORA_ID': administradoraId
    }
    Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_CAMPO_IMPORTE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.Execute((data) => _callbackActualizarComboImporte(data), null, null, "CONTABILIDAD");
}

function _callbackActualizarComboImporte(data) {
    let valoresCampoImporte = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CAMPO_IMPORTE).Recordset0.Rows;

    _dispatch({ type: ABMMODELOS_CARGAR_CAMPO_IMPORTE, valoresCampoImporte });

    let combos = JSON.parse(JSON.stringify(_getState().abmModelos.combosABMModelos));

    let valorEncontrado = valoresCampoImporte.filter(e => e.Id == combos.modalAltaEdicionRenglonContable.comboCampoImporteSeleccionado)

    combos.modalAltaEdicionRenglonContable.comboCampoImporteSeleccionado && valorEncontrado.length > 0
    ?
    combos.modalAltaEdicionRenglonContable.comboCampoImporteSeleccionado = combos.modalAltaEdicionRenglonContable.comboCampoImporteSeleccionado
    : 
    combos.modalAltaEdicionRenglonContable.comboCampoImporteSeleccionado = valoresCampoImporte[0].Id;
    _dispatch({ type: ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES, combos });
    
}

function cargarInformacionCriteriosContables(tipoMovimiento){
    _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModalRenglones", valor: true });

    let rbMarca = _getState().abmModelos.radioButtonsABMModelos.rbMarca;
    let administradoraId = rbMarca.toLowerCase() == 'visa' ? 1 : rbMarca.toLowerCase() == 'cabal' ? 2 : 3;
    
    let param = {
        'TIPO_MOVIMIENTO_ID' : tipoMovimiento,
        'ADMINISTRADORA_ID': administradoraId
    }
    Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_CRIT_SELECCION', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.Execute((data) => _callbackActualizarCriteriosContables(data), null, null, "CONTABILIDAD");
}

function _callbackActualizarCriteriosContables(data) {
    let valoresCriteriosContables = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CRIT_SELECCION).Recordset0.Rows;
    let rbMarca = _getState().abmModelos.radioButtonsABMModelos.rbMarca;
    let administradoraId = rbMarca.toLowerCase() == 'visa' ? 1 : rbMarca.toLowerCase() == 'cabal' ? 2 : 3;
    let param = {
        'ADMINISTRADORA_ID': administradoraId,
        'SOLO_ACTIVOS' : 1,
    }

    valoresCriteriosContables.forEach(element => {
        Engine1Proxy.AddDataSourcesRequests(param, element.ProcesoCriterioSeleccion, 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product')
    });
    Engine1Proxy.Execute((data) => _callbackArmadoCombosCriteriosContables(data,valoresCriteriosContables), null, null, "CONTABILIDAD");
}

function _callbackArmadoCombosCriteriosContables(data,valoresCriteriosContables){
    let arrayContenedor = [];
    let criteriosEdicion = _getState().abmModelos.criteriosRenglon.filter(c => c.ModeloDetalleId === _getState().abmModelos.renglonEdicion.ModeloContableDetalleId && _getState().abmModelos.renglonEdicion.ModeloContableDetalleId != undefined)
    criteriosEdicion = criteriosEdicion.filter(c => !c.DeleteInstance || c.DeleteInstance !== true);
    let criteriosPorReferencia = _getState().abmModelos.renglonEdicion.referenciaRenglonCriterio >= 0 ? _getState().abmModelos.criteriosRenglon.filter(c => c.referenciaRenglonCriterio === _getState().abmModelos.renglonEdicion.referenciaRenglonCriterio  && !c.DeleteInstance) : null;
    criteriosEdicion = criteriosPorReferencia && criteriosPorReferencia.length > 0 ? criteriosPorReferencia : criteriosEdicion;
    
    valoresCriteriosContables.forEach(element => {

        let valoresCriteriosProceso = JSON.parse(data[element.ProcesoCriterioSeleccion]).Recordset0.Rows;

        element.PermiteSeleccionMultiple ?
        arrayContenedor.push(
            {
                id: element.Id,
                descripcion:element.Descripcion,
                nombreCombo:element.ProcesoCriterioSeleccion,
                esSeleccionMultiple:element.PermiteSeleccionMultiple,
                valoresCriterios: criteriosEdicion && criteriosEdicion.find(c => element.Id == c.CampoCriterioId )? 
                                  valoresCriteriosProceso.map(v => ({...v, estaSeleccionado: false})) 
                                  : 
                                  valoresCriteriosProceso.filter(v => v.Activo).map(v => ({...v, estaSeleccionado: true})),
                valorSeleccionadoCombo: (criteriosEdicion && criteriosEdicion.find(c => element.Id == c.CampoCriterioId ))
                                        || valoresCriteriosProceso.filter(v => v.Activo).length == 0 
                                        ? "-1":"999",
                mostrarLinkVerMas: true
            }
        )
        :
        arrayContenedor.push(
            {
                id: element.Id,
                descripcion:element.Descripcion,
                nombreCombo:element.ProcesoCriterioSeleccion,
                esSeleccionMultiple:element.PermiteSeleccionMultiple,
                valoresCriterios: valoresCriteriosProceso.filter(v => v.Activo).map(v => ({...v, estaSeleccionado: false})),
                valorSeleccionado:0
            }
        )
    });

    criteriosEdicion.forEach(ce => {
        let elementoContenedor = arrayContenedor.find(ac => ac.id == ce.CampoCriterioId);
        if (elementoContenedor) {
        if (ce.ValorCriterio == "Todos" || (ce.ValorCriterio === null && elementoContenedor.valoresCriterios.every(v => !v.estaSeleccionado))) {
                elementoContenedor.valorSeleccionadoCombo = "999";
                elementoContenedor.valoresCriterios = elementoContenedor.valoresCriterios.map(v => ({...v, estaSeleccionado: true}));
                let index = arrayContenedor.indexOf(elementoContenedor);
                arrayContenedor[index] = elementoContenedor;
            }
            let coincidencia = elementoContenedor.valoresCriterios.find(vc => vc.Codigo.toString().trim() == ce.ValorCriterio);
            if (coincidencia) {
                coincidencia.estaSeleccionado = true;
                if (!elementoContenedor.esSeleccionMultiple){
                    elementoContenedor.valorSeleccionado = coincidencia.Id;
                }
                let index = arrayContenedor.indexOf(elementoContenedor);
                arrayContenedor[index] = elementoContenedor;
            }

        }
    });

    arrayContenedor = arrayContenedor.map(obj => ({
        ...obj,
        valoresCriterios: obj.valoresCriterios.filter(item => item.Activo || item.estaSeleccionado)
    }));
    
    _dispatch({ type: ABMMODELOS_CARGAR_COMBOS_CRITERIOS_CONTABLES, arrayContenedor });
    _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModalRenglones", valor: false });

}

export function elegirOpcionSelector(seccionInput, nombreSelector, selectorElegido, agregarSelectorElegido) {
    return (dispatch, getState) => {
        let combos = JSON.parse(JSON.stringify(_getState().abmModelos.combosABMModelos));
        if (selectorElegido == 999) {
            if (agregarSelectorElegido) {
                combos[seccionInput].contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreSelector})[0].valoresCriterios.map(e => e.estaSeleccionado = true)
            } else {
                combos[seccionInput].contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreSelector})[0].valoresCriterios.map(e => e.estaSeleccionado = false)
            }
            
        }
        else{
            if (agregarSelectorElegido) {
                combos[seccionInput].contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreSelector})[0].valoresCriterios.filter(f => {return f.Id == selectorElegido})[0].estaSeleccionado = true;

            } else {
                combos[seccionInput].contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreSelector})[0].valoresCriterios.filter(f => {return f.Id == selectorElegido})[0].estaSeleccionado = false;

            }
        }
        selectorElegido == 999 && agregarSelectorElegido
            ? combos[seccionInput].contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreSelector})[0].valorSeleccionadoCombo = "999"
            : combos[seccionInput].contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreSelector})[0].valorSeleccionadoCombo = "-1";
            dispatch({ type: ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES, combos });
    }
}

export function setMostrarLinkVerMas(seccionInput, nombreCombo, valor){
    return (dispatch) => {
    let combos = JSON.parse(JSON.stringify(_getState().abmModelos.combosABMModelos));
    combos[seccionInput].contenedorCombosCriteriosContables.filter(c => {return c.nombreCombo == nombreCombo})[0].mostrarLinkVerMas = valor

    dispatch({ type: ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES, combos });
    }
}

export function datosEdicionRenglon(renglon, criterios) {
    return (dispatch) => {
        if (JSON.stringify(renglon) != '{}' ) {
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB: "modalAltaEdicionRenglonContable", nombreRB: "rbTipoApertura", valorRB: renglon.TipoApertura });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB: "modalAltaEdicionRenglonContable", nombreRB: "rbTipoRenglon", valorRB: renglon.TipoRenglon });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB: "modalAltaEdicionRenglonContable", nombreRB: "rbReferenciaRenglon", valorRB: renglon.TipoReferencia });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB: "modalAltaEdicionRenglonContable", nombreRB: "rbTipoOperacion", valorRB: renglon.TipoOperacion });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB: "modalAltaEdicionRenglonContable", nombreRB: "rbMonedaSalida", valorRB: renglon.ModeloMonedaSalidaId });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_RB, seccionRB: "modalAltaEdicionRenglonContable", nombreRB: "rbSignoImporte", valorRB: renglon.SignoCampo });
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_INPUT, seccionInput: "modalAltaEdicionRenglonContable", nombreInput: "inputDescripcion", valorInput: renglon.DescripcionRenglon });
        _dispatch({ type: ABMMODELOS_CAMBIAR_VALOR_INPUT, seccionInput: "modalAltaEdicionRenglonContable", nombreInput: "inputReferenciaRenglon", valorInput: renglon.ValorReferencia });
        
        _dispatch({ type: ABMMODELOS_SELECCIONAR_OPCION_COMBO, nombreCombo: "comboTipoMovimientoSeleccionado", valorCombo: renglon.TipoMovimientoId });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_OPCION_COMBO, nombreCombo: "comboCentroCostoSeleccionado", valorCombo: renglon.CentroCostoId });
        _dispatch({ type: ABMMODELOS_SELECCIONAR_OPCION_COMBO, nombreCombo: "comboCampoImporteSeleccionado", valorCombo: renglon.CampoImporteId });


        cargarValoresAltaEdicionRenglonContable(renglon)
        }
        _dispatch({ type: ABMMODELOS_RENGLON_EDICION, renglon});
    };
}

export function validarGuardarModalAltaEdicionRenglon(renglonEdicion) {
    LogHelper.In(validarGuardarModalAltaEdicionRenglon.name);

    return (dispatch, getState) => {

        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.modalAltaEdicionRenglonContable));

        let radioButtons = JSON.parse(JSON.stringify(getState().abmModelos.radioButtonsABMModelos.modalAltaEdicionRenglonContable));

        let combos = JSON.parse(JSON.stringify(getState().abmModelos.combosABMModelos.modalAltaEdicionRenglonContable));
        
        let errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));

        let combosDinamicos = JSON.parse(JSON.stringify(getState().abmModelos.combosABMModelos));

        if(errores.modalAltaEdicionRenglonContable == ""){
            errores.modalAltaEdicionRenglonContable = {};
        }
        errores.modalAltaEdicionRenglonContable.inputDescripcion = "";
        errores.modalAltaEdicionRenglonContable.inputReferenciaRenglon = "";
        errores.modalAltaEdicionRenglonContable.inputCuentaContable = "";
        errores.modalAltaEdicionRenglonContable.combosCriteriosContables= "";
        _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores});



        if (inputs.inputDescripcion == "") {
            let errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));
            errores.modalAltaEdicionRenglonContable.inputDescripcion = "Debe ingresar una descripción";
            _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores});
        }
        if (radioButtons.rbReferenciaRenglon == 3// valor que va en otra
            && (inputs.inputReferenciaRenglon == "" || inputs.inputReferenciaRenglon == null)){
            let errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));
            errores.modalAltaEdicionRenglonContable.inputReferenciaRenglon = "Debe ingresar una referencia de renglón";
            _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores});
        }
        if (inputs.cuentasSeleccionadas.inputCuentaContable == "") {
            let errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));
            errores.modalAltaEdicionRenglonContable.inputCuentaContable = "Debe ingresar una cuenta contable";
            _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores});
        }
        let nuevosCriterios = [];

        combos.contenedorCombosCriteriosContables.forEach(

            p => {
                let criteriosContables = p.valoresCriterios.filter(e => e.estaSeleccionado == true);
                if (radioButtons.rbTipoRenglon === 1 && criteriosContables.length === 0 && p.esSeleccionMultiple) {
                    const errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));
                    errores.modalAltaEdicionRenglonContable.combosCriteriosContables = "Se debe ingresar un valor para este criterio contable.";
                    _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores });
                } 
                else if(!p.esSeleccionMultiple){
                    if(p.valorSeleccionado == 0){
                    let errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));
                    errores.modalAltaEdicionRenglonContable.combosCriteriosContables= "Se debe ingresar un valor para este criterio contable.";
                    _dispatch({ type: ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR, errores});
                    }
                }
            }
        )
        errores = JSON.parse(JSON.stringify(getState().abmModelos.errorValidacion));

        if (errores.modalAltaEdicionRenglonContable.inputDescripcion == "" &&
            errores.modalAltaEdicionRenglonContable.inputReferenciaRenglon == ""&&
            errores.modalAltaEdicionRenglonContable.inputCuentaContable == "" &&
            errores.modalAltaEdicionRenglonContable.combosCriteriosContables== "") {

            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModales", valor: true });
            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, spinner: "mostrarSpinnerModales", valor: false });
            
            let renglonEdicion = JSON.parse(JSON.stringify(getState().abmModelos.renglonEdicion));
            let renglones = JSON.parse(JSON.stringify(getState().abmModelos.datosRenglones));
            let referenciaRenglonEdicion = _getState().abmModelos.renglonEdicion.referenciaRenglonCriterio;
            let criterios = JSON.parse(JSON.stringify(getState().abmModelos.criteriosRenglon));

            let cuentaContableSeleccionada =  inputs.cuentasContablesFiltradas.find(e => e.Codigo == inputs.cuentasSeleccionadas.inputCuentaContable)
            if (!cuentaContableSeleccionada) {
                cuentaContableSeleccionada = {
                    Id: renglonEdicion.CuentaContableId,
                    Codigo: renglonEdicion.CuentaContableCodigo,
                    Descripcion: renglonEdicion.CuentaContableDescripcion
                }
            }
            let diasDiferimiento = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.inputDiasDiferimiento));
            let inputNombreModelo = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos.inputNombreModelo));
            let radiosGenerales = JSON.parse(JSON.stringify(getState().abmModelos.radioButtonsABMModelos))
            let signoImporte = radioButtons.rbTipoRenglon == 1 ? (radioButtons.rbSignoImporte == "A" || radioButtons.rbSignoImporte == null) ? null : radioButtons.rbSignoImporte == "P" ? "+" : "-" : null;
            let monedaCodigo = (radioButtons.rbMonedaSalida.toString().toUpperCase() == "P" || radioButtons.rbMonedaSalida.toString().toUpperCase() == "1") ? "PESO" : "DOLAR";
            let monedaSeleccionada = getState().abmModelos.monedasActivas.filter(e => monedaCodigo == e.Codigo)[0];
            let marcaSeleccionada = getState().abmModelos.marcasActivas.filter(e => radiosGenerales.rbMarca.toUpperCase() == e.Codigo)[0];
            let descripcionTipoMovimiento = radioButtons.rbTipoRenglon == 1 ? combos.comboTiposMovimientos.filter(e => e.Id == combos.comboTipoMovimientoSeleccionado)[0].Descripcion : null;
            let usuario = _executionContext.login;
            let referenciaRenglonCopia = JSON.parse(JSON.stringify(getState().abmModelos.referenciaRenglonCopia));
            let iso = new Date().toISOString().replace("Z","");
            let ultimoRenglon = renglones.some(renglon => !renglon.DeleteInstance) ? Math.max(...renglones.filter(renglon => !renglon.DeleteInstance).map(renglon => renglon.NroRenglon)) : 0;
            let importeDescripcion = radioButtons.rbTipoRenglon == 1 ? combos.comboCampoImporte.filter(e => e.Id == combos.comboCampoImporteSeleccionado)[0].Descripcion : null;
            let nroRenglon = renglonEdicion.NroRenglon ? renglonEdicion.NroRenglon : ultimoRenglon + 1;
            combos.contenedorCombosCriteriosContables.forEach(

                p => {
                    if(p.valorSeleccionadoCombo != "999"){
                    let criteriosContables = p.valoresCriterios.filter(e => e.estaSeleccionado == true)
                        criteriosContables.forEach(
                            nc => {
                                nuevosCriterios.push({
                                    Id: null,
                                    CampoCriterioId: p.id,
                                    DeleteInstance: false,
                                    ModeloDetalleId: Object.keys(renglonEdicion).length !== 0 ? renglonEdicion.ModeloContableDetalleId: null,
                                    DescripcionCriterio: p.descripcion,
                                    ValorCriterio: nc.Codigo.toString().trim(),
                                    DescripcionValorCriterio: nc.Descripcion,
                                    referenciaRenglonCriterio : referenciaRenglonEdicion !== undefined && referenciaRenglonEdicion !== null ? referenciaRenglonEdicion : referenciaRenglonCopia
                                })
                            }
                        )
                    }
                    else{
                        nuevosCriterios.push({
                            Id: null,
                            CampoCriterioId: p.id,
                            DeleteInstance: false,
                            ModeloDetalleId: Object.keys(renglonEdicion).length !== 0 ? renglonEdicion.ModeloContableDetalleId: null,
                            DescripcionCriterio: p.descripcion,
                            ValorCriterio: null,
                            DescripcionValorCriterio: null,
                            referenciaRenglonCriterio : referenciaRenglonEdicion !== undefined && referenciaRenglonEdicion !== null ? referenciaRenglonEdicion : referenciaRenglonCopia
                        })
                    }
                }
            )
            if(renglonEdicion.NroRenglon){
            let criteriosFiltrados = criterios.map(criterio => {
                if (criterio.ModeloDetalleId === renglonEdicion.ModeloContableDetalleId) {
                  return { ...criterio, DeleteInstance: true };
                } else {
                  return criterio;
                }
              });
              criterios = criteriosFiltrados
            }
           criterios = radioButtons.rbTipoRenglon == 1 ? criterios.concat(nuevosCriterios) : criterios; 
           
           criterios = criterios.filter(criterio => !(criterio.Id === null && criterio.DeleteInstance === true));

           if(!renglonEdicion.NroRenglon){
            renglones.push({
                "ModeloContableCabeceraId": null,
                "DescripcionModelo": inputNombreModelo,
                "AdministradoraId": marcaSeleccionada.Id,
                "SucursalId": combosDinamicos.comboSucursal,
                "AbreSucursal": false,
                "TipoSucursal": radiosGenerales.rbTipoSucursal,
                "AbreSocio": false,
                "ModeloMonedaId": monedaSeleccionada.Id,
                "ConfirmacionAutomatica": false,
                "TipoConsolidacion": radiosGenerales.rbTipoConsolidacion,
                "IndicadorInterfazId": null,
                "DiasDiferimiento": diasDiferimiento,
                "RequiereReverso": false,
                "FechaBaja": null,
                "ModeloContableDetalleId": null,
                "NroRenglon": nroRenglon,
                "DescripcionRenglon": inputs.inputDescripcion,
                "TipoRenglon": radioButtons.rbTipoRenglon,
                "TipoApertura": radioButtons.rbTipoApertura,
                "TipoReferencia": radioButtons.rbReferenciaRenglon,
                "ValorReferencia": inputs.inputReferenciaRenglon,
                "ModeloMonedaSalidaId": monedaSeleccionada.Id,
                "TipoOperacion": radioButtons.rbTipoOperacion,
                "CuentaContableId": cuentaContableSeleccionada.Id,
                "CentroCostoId": combos.comboCentroCostoSeleccionado,
                "TipoMovimientoId": combos.comboTipoMovimientoSeleccionado,
                "CampoImporteId": combos.comboCampoImporteSeleccionado,
                "CampoImporteNombre": importeDescripcion,
                "CampoImporteDescripcion": importeDescripcion,
                "SignoCampo": signoImporte,
                "AdministradoraCodigo": marcaSeleccionada.Codigo,
                "AdministradoraDescripcion": marcaSeleccionada.Descripcion,
                "SucursalCodigo": null,
                "SucursalDescripcion": null,
                "ModeloMonedaCodigo": monedaSeleccionada.Codigo,
                "ModeloMonedaDescripcion": monedaSeleccionada.Descripcion,
                "IndicInterfazCodigo": null,
                "IndicInterfazDescripcion": null,
                "MonedaSalidaCodigo": monedaSeleccionada.Codigo,
                "MonedaSalidaDescripcion": monedaSeleccionada.Descripcion,
                "CuentaContableCodigo": cuentaContableSeleccionada.Codigo,
                "CuentaContableDescripcion": cuentaContableSeleccionada.Descripcion,
                "CentroCostoCodigo": combos.comboCentroCostoSeleccionado,
                "CentroCostoDescripcion": null,
                "TipoMovDescripcion": descripcionTipoMovimiento,
                "DiccTipoMovNombre": null,
                "DiccTipoMovDescripcion": null,
                "UsuarioAlta": usuario,
                "UsuarioConfirmacion": null,
                "FechaConfirmacion": iso,
                "referenciaRenglonCriterio":referenciaRenglonCopia
            })
            referenciaRenglonCopia += 1 
        }else{
            renglonEdicion = {
                "ModeloContableCabeceraId": renglonEdicion.ModeloContableCabeceraId,
                "DescripcionModelo": inputNombreModelo,
                "AdministradoraId": marcaSeleccionada.Id,
                "SucursalId": combosDinamicos.comboSucursal,
                "AbreSucursal": renglonEdicion.AbreSucursal,
                "TipoSucursal": radiosGenerales.rbTipoSucursal,
                "AbreSocio": renglonEdicion.AbreSocio,
                "ModeloMonedaId": monedaSeleccionada.Id,
                "ConfirmacionAutomatica": renglonEdicion.ConfirmacionAutomatica,
                "TipoConsolidacion": radiosGenerales.rbTipoConsolidacion,
                "IndicadorInterfazId": renglonEdicion.IndicadorInterfazId,
                "DiasDiferimiento": renglonEdicion.diasDiferimiento,
                "RequiereReverso": renglonEdicion.RequiereReverso,
                "FechaBaja": renglonEdicion.FechaBaja,
                "ModeloContableDetalleId": renglonEdicion.ModeloContableDetalleId,
                "NroRenglon": renglonEdicion.NroRenglon,
                "DescripcionRenglon": inputs.inputDescripcion,
                "TipoRenglon": radioButtons.rbTipoRenglon,
                "TipoApertura": radioButtons.rbTipoApertura,
                "TipoReferencia": radioButtons.rbReferenciaRenglon,
                "ValorReferencia": inputs.inputReferenciaRenglon,
                "ModeloMonedaSalidaId": monedaSeleccionada.Id,
                "TipoOperacion": radioButtons.rbTipoOperacion,
                "CuentaContableId": cuentaContableSeleccionada.Id,
                "CentroCostoId": combos.comboCentroCostoSeleccionado,
                "TipoMovimientoId": combos.comboTipoMovimientoSeleccionado,
                "CampoImporteId": combos.comboCampoImporteSeleccionado,
                "CampoImporteNombre": importeDescripcion,
                "CampoImporteDescripcion": importeDescripcion,
                "SignoCampo": signoImporte,
                "AdministradoraCodigo": marcaSeleccionada.Codigo,
                "AdministradoraDescripcion": marcaSeleccionada.Descripcion,
                "SucursalCodigo": renglonEdicion.SucursalCodigo,
                "SucursalDescripcion": renglonEdicion.SucursalDescripcion,
                "ModeloMonedaCodigo": monedaSeleccionada.Codigo,
                "ModeloMonedaDescripcion": monedaSeleccionada.Descripcion,
                "IndicInterfazCodigo": renglonEdicion.IndicInterfazCodigo,
                "IndicInterfazDescripcion": renglonEdicion.IndicInterfazDescripcion,
                "MonedaSalidaCodigo": monedaSeleccionada.Codigo,
                "MonedaSalidaDescripcion": monedaSeleccionada.Descripcion,
                "CuentaContableCodigo": cuentaContableSeleccionada.Codigo,
                "CuentaContableDescripcion": cuentaContableSeleccionada.Descripcion,
                "CentroCostoCodigo": combos.comboCentroCostoSeleccionado,
                "CentroCostoDescripcion": renglonEdicion.CentroCostoDescripcion,
                "TipoMovDescripcion": descripcionTipoMovimiento,
                "DiccTipoMovNombre": renglonEdicion.DiccTipoMovNombre,
                "DiccTipoMovDescripcion": renglonEdicion.DiccTipoMovDescripcion,
                "UsuarioAlta": usuario,
                "UsuarioConfirmacion": renglonEdicion.UsuarioConfirmacion,
                "FechaConfirmacion": iso,
                "referenciaRenglonCriterio":referenciaRenglonEdicion
            }
            // Encontrar el índice del elemento a reemplazar
            const index = renglones.findIndex((renglon) => renglon.NroRenglon === renglonEdicion.NroRenglon);

            // Verificar si se encontró el índice
            if (index !== -1) {
            // Reemplazar el elemento en el índice encontrado
            renglones[index] = renglonEdicion;
            }
            renglones.sort((a, b) => (a.NroRenglon > b.NroRenglon) ? 1 : -1);
        }
            

            //Borro los valores que se crearon dinamicamente
            combos.contenedorCombosCriteriosContables.forEach(
                element =>  delete combosDinamicos[element.nombreCombo]
                
            )
            _dispatch({ type: ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES, combos: combosDinamicos});
            _dispatch({ type: ABMMODELOS_AGREGAR_RENGLON, renglones, criterios, referenciaRenglonCopia });
            _dispatch({ type: ABMMODELOS_REINICIAR_VALORES_MODAL, nombreModal: "modalAltaEdicionRenglonContable" });

            //Valido los renglones que no fueron eliminados desde la grilla
            let renglonesIguales = _validarRenglonesIguales(renglones.filter(renglon => {return !renglon.DeleteInstance}));

            if(renglonesIguales.existenRenglonesIguales) {
                _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: "Existen renglones con las mismas características: N° " + renglonesIguales.renglon1 + " y N° " + renglonesIguales.renglon2 + "."});
            } else {
                _dispatch({ type: ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES, mensaje: ""});
            }

            _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL, nombreModal: "modalAltaEdicionRenglonContable", mostrarModal: false });
            sessionStorage.setItem('PantallaCambios', true);
        }
    }
}


export function descargarExcel(data) {
    return (dispatch) => {
        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: true });

        let fechaActual = formatearFecha(new Date().toLocaleDateString('en-GB'));
        let nombreArchivo = fechaActual + "_dataModelosContables.xlsx";
        let nombreHoja1 = "Datos generales";
        let nombreHoja2 = "Renglones contables";
        let nombreReporte = "Datos del Modelo N°" + data.DatosGenerales.CodigoModelo

        let params = {
            FileConfigName: "ModelosContables_Excel",
            ExcelBody: [
                {
                    SheetName: nombreHoja1,
                    Content: {
                        ModelosContablesContent: [data.DatosGenerales]
                    }
                },
                {
                    SheetName: nombreHoja2,
                    Content: {
                        ModelosContablesContent: data.RenglonesContables
                    }
                }
            ],
            FileName: nombreArchivo,
            ReportTitle: nombreReporte
        }

        AxiosManager.AxiosRequest('post', GetApiUrlsHelper.GetAxiosUrl('ExcelFile'), null, params, 'arraybuffer', _callbackFileDownload, _callbackMostrarMensajeError)
    };
}

function _callbackFileDownload(response) {
    try {
        if(response) {
            const nombreArchivo = JSON.parse(response.config.data)?.FileName;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', nombreArchivo);
            document.body.appendChild(link);
            link.click();

            _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
        }
    } catch (error) {
        _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
        _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + error, redireccionarPantallaPrincipal: false });
    }
}


function _callbackMostrarMensajeError(response) {
    _dispatch({ type: ABMMODELOS_MOSTRAR_SPINNER, valor: false });
    _dispatch({ type: ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + response, redireccionarPantallaPrincipal: false });
}

/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++FUNCIONES AUXILIARES++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
function obtenerOpcionesCuentasFiltradas(cuentasContables, cuentasSeleccionadas, nombreInput, valorInput) {
    let cuentasContablesFiltradosBuscador = [];

    cuentasContablesFiltradosBuscador = filtrarCuentasContables(cuentasContables, valorInput);

    if(cuentasSeleccionadas.inputReemplazarCuenta && nombreInput != "inputReemplazarCuenta") {
        cuentasContablesFiltradosBuscador = cuentasContablesFiltradosBuscador.filter(cuenta => {return cuenta.Codigo != cuentasSeleccionadas.inputReemplazarCuenta})
    }

    if(cuentasSeleccionadas.inputReemplazarCon && nombreInput != "inputReemplazarCon") {
        cuentasContablesFiltradosBuscador = cuentasContablesFiltradosBuscador.filter(cuenta => {return cuenta.Codigo != cuentasSeleccionadas.inputReemplazarCon})
    }

    if(nombreInput == "inputReemplazarCon") {
        let cuentaSeleccionada = cuentasContables.filter(cuenta => {return cuenta.Codigo == cuentasSeleccionadas.inputReemplazarCuenta})[0];

        //Trae las cuentas contables del renglon origian que no esten en el renglon destino
        if(cuentaSeleccionada.TipoOperacion != 0) {
            cuentasContablesFiltradosBuscador = cuentasContablesFiltradosBuscador.filter(cuenta => {return cuenta.TipoOperacion == cuentaSeleccionada.TipoOperacion || cuenta.TipoOperacion == 0});
        }

        if(cuentaSeleccionada.MonedaId != 0) {
            cuentasContablesFiltradosBuscador = cuentasContablesFiltradosBuscador.filter(cuenta => {return cuenta.MonedaId == cuentaSeleccionada.MonedaId || cuenta.MonedaId == 0});
        }
    }

    return cuentasContablesFiltradosBuscador;
}

function filtrarCuentasContables(cuentas, valorInput) {
    let cuentasContablesFiltradosBuscador = [];

    if(valorInput){
        let cuentasContablesFiltradosCodigo = cuentas.filter( function(c) {
            let cuentasContablesFiltrados = c["Codigo"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return cuentasContablesFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let cuentasContablesFiltradosDescripcion = cuentas.filter( function(c) {
            let cuentasContablesFiltrados = c["Descripcion"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return cuentasContablesFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

         let cuentasContablesMergeados = [...cuentasContablesFiltradosCodigo, ...cuentasContablesFiltradosDescripcion];

         cuentasContablesFiltradosBuscador = [... new Set(cuentasContablesMergeados)];
    }
    else {
        cuentasContablesFiltradosBuscador = cuentas;
    }

    return cuentasContablesFiltradosBuscador;
}


function busquedaModelosContables(modelos, modelosSeleccionados, input, modeloEdicion) {
    if(modelosSeleccionados.length > 0) {
        //Se quitan los modelos que ya fueron seleccionados
        modelos = modelosSeleccionados[0]?.Codigo == "Todos" ? [] : modelos.filter(m => { return !modelosSeleccionados.some(ms => ms.Codigo == m.Codigo) });
    }

    //Se quita modelo seleccionado para editar en el caso de tratarse una edición de modelo
    if(modeloEdicion) {
        modelos = modelos.filter(m => m.Codigo != modeloEdicion);
    }

    return filtrarModelos(modelos, input);
}


function filtrarModelos(modelos, valorInput) {
    let modelosFiltradosBuscador = [];

    if(valorInput){
        let modelosFiltradosCodigo = modelos.filter( function(m) {
            let modelosFiltrados = m["Codigo"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let modelosFiltradosDescripcion = modelos.filter( function(m) {
            let modelosFiltrados = m["Descripcion"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

         let modelosMergeados = [...modelosFiltradosCodigo, ...modelosFiltradosDescripcion];

         modelosFiltradosBuscador = [... new Set(modelosMergeados)];
    }
    else {
        modelosFiltradosBuscador = modelos;
    }

    return modelosFiltradosBuscador;
}


function agregarRegistroInactivo(registrosActivos, id, codigo, descripcion) {
    let esRegistroInactivo = !registrosActivos.some(reg => reg.Id == id);

    if(esRegistroInactivo) {
        registrosActivos = [...registrosActivos, {Id: id, Codigo: codigo, Descripcion: descripcion}].sort((a,b) => a.Id - b.Id);
    }

    //Me guardo la marca correspondiente al modelo a editar recibida de la obtención de datos
    return registrosActivos;
}


export function armarDatosExportacionExcel(datosRenglones, datosCriterios) {
    return function(dispatch, getState) {
        // let state = getState();
        let inputs = JSON.parse(JSON.stringify(getState().abmModelos.inputsABMModelos));
        let checks = JSON.parse(JSON.stringify(getState().abmModelos.checksABMModelos));
        let radioButtons = JSON.parse(JSON.stringify(getState().abmModelos.radioButtonsABMModelos));
        let combos = JSON.parse(JSON.stringify(getState().abmModelos.combosABMModelos));

        let objetoDatosGenerales = {
            CodigoModelo : inputs.inputCodigoModelo,
            NombreModelo : inputs.inputNombreModelo,
            Habilitado : checks.checkModeloHabilitado ? "Sí" : "No",
            Marca: radioButtons.rbMarca,
            MonedaGeneral: radioButtons.rbMoneda,
            Sucursal: combos.comboSucursal,
            AperturaPorSucursal: checks.checkAperturaPorSucursal ? "Sí" : "No",
            TipoSucursal: radioButtons.rbTipoSucursal,
            AperturaPorSocio: checks.checkAperturaPorSocio ? "Sí" : "No",
            ConfirmacionAutomatica: checks.checkConfirmacionAutomatica ? "Sí" : "No",
            RequiereReverso: checks.checkRequiereReverso ? "Sí" : "No",
            DiasDiferimiento: inputs.inputDiasDiferimiento,
            IndicadorInterfaz: inputs.inputIndicadorInterfaz,
            TipoConsolidacion : radioButtons.rbTipoConsolidacion
        }
        let datosExcelFinal = {
            DatosGenerales: objetoDatosGenerales,
            RenglonesContables: []
          };
          
          datosRenglones.map(renglon => {
            let objetoDatosRenglones = {
              tipoOperacion: renglon.TipoOperacion == 0 ? "AMBOS" : renglon.TipoOperacion == 1 ? "DEBE" : "HABER",
              nroRenglon: renglon.NroRenglon,
              descripcion: renglon.DescripcionRenglon,
              cuentaContable: renglon.CuentaContableCodigo + " " + renglon.CuentaContableDescripcion,
              tipoMovimiento: renglon.TipoMovDescripcion,
              campo: renglon.CampoImporteDescripcion,
              moneda: renglon.MonedaSalidaDescripcion,
              tipoRenglon: renglon.TipoRenglon == 1 ? "Automático" : renglon.TipoRenglon == 2 ? "Manual" : "Balanceo Automático",
              tipoApertura: renglon.TipoApertura == 1 ? "Sin Apertura" : renglon.TipoApertura == 2 ? "Socio" : "Movimiento",
              centroCosto: renglon.CentroCostoId == 0 ? "Ninguno" : renglon.CentroCostoDescripcion ? renglon.CentroCostoDescripcion : "Asociado a la sucursal",
              signo: renglon.SignoCampo ? renglon.SignoCampo : "Ambos"
            };

            let arrayCriterios = datosCriterios
            .filter(criterio => {
                // Verifica si los modelos tienen IDs iguales, excluyendo cuando son null
                if (criterio.ModeloDetalleId !== null && renglon.ModeloContableDetalleId !== null) {
                    return criterio.ModeloDetalleId === renglon.ModeloContableDetalleId;
                }
                // Verifica si ambos modelos son null y tienen la misma referencia de renglón
                return criterio.ModeloDetalleId === null && renglon.ModeloContableDetalleId === null &&
                    criterio.referenciaRenglonCriterio === renglon.referenciaRenglonCriterio;
            })
            .map(c => `${c.DescripcionCriterio}: ${c.DescripcionValorCriterio}`);

            

            let objetoCriterios = {};
          
            arrayCriterios.forEach(criterio => {
              let [key, value] = criterio.split(':').map(item => item.trim());
              objetoCriterios[key] = objetoCriterios[key] ? `${objetoCriterios[key]}, ${value}` : value;
            });
          
            let renglonFinal = {
              ...objetoDatosRenglones,
              criteriosContables: objetoCriterios
            };
          
            datosExcelFinal.RenglonesContables.push(renglonFinal);
          });

        _dispatch({ type: ABMMODELOS_ACTUALIZAR_DATOSEXCEL, datosExcelFinal  });

    };
}


function busquedaIndicadoresInterfaz(indicadoresInterfaz, input, indicadorInterfazEdicion) {
        //Se quita modelo seleccionado para editar en el caso de tratarse una edición de modelo
        if(indicadorInterfazEdicion) {
            indicadoresInterfaz = indicadoresInterfaz.filter(i => i.Id != indicadorInterfazEdicion);
        }

        return filtrarIndicadores(indicadoresInterfaz, input);
    }


function filtrarIndicadores(indicadoresInterfaz, valorInput) {
    let indicadoresFiltradosBuscador = [];

    if(valorInput){
        let indicadoresFiltradosCodigo = indicadoresInterfaz.filter( function(m) {
            let indicadoresFiltrados = m["Codigo"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return indicadoresFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let indicadoresFiltradosDescripcion = indicadoresInterfaz.filter( function(m) {
            let indicadoresFiltrados = m["Descripcion"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return indicadoresFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

            let indicadoresMergeados = [...indicadoresFiltradosCodigo, ...indicadoresFiltradosDescripcion];

            indicadoresFiltradosBuscador = [... new Set(indicadoresMergeados)];
    }
    else {
        indicadoresFiltradosBuscador = indicadoresInterfaz;
    }

    return indicadoresFiltradosBuscador;
}

function formatearFecha(fecha) {
    let diaFecha = fecha.substring(0,2);
    let mesFecha = fecha.substring(3,5);
    let anioFecha = fecha.substring(6,10);

    return anioFecha + mesFecha + diaFecha;
}